// src/components/property-reviews-list.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
  if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null) return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _to_consumable_array(arr) {
  return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment SpannableTextContentsFragment on EGDSSpannableText {\n    text\n    contents {\n      ...SpannableTextContentFragment\n    }\n    egdsElementId\n  }\n\n  fragment SpannableTextContentFragment on EGDSText {\n    ...SpannableContentPlainTextFragment\n    ...SpannableContentStandardLinkFragment\n    ...SpannableContentInlineLinkFragment\n  }\n\n  fragment SpannableContentPlainTextFragment on EGDSPlainText {\n    text\n  }\n\n  fragment SpannableContentStandardLinkFragment on EGDSStandardLink {\n    action {\n      target\n      resource {\n        ... on HttpURI {\n          relativePath\n          value\n        }\n      }\n    }\n    text\n    size\n    icon {\n      description\n      id\n      size\n      theme\n    }\n    iconPosition\n  }\n\n  fragment SpannableContentInlineLinkFragment on EGDSInlineLink {\n    action {\n      target\n      resource {\n        ... on HttpURI {\n          relativePath\n          value\n        }\n      }\n    }\n    text\n    size\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment InputFieldParts on EGDSInputField {\n    value\n    label\n    placeholder\n    validations {\n      errorMessage\n      __typename\n      ... on EGDSMaxLengthInputValidation {\n        maxLength\n      }\n      ... on EGDSMinLengthInputValidation {\n        minLength\n      }\n      ... on EGDSRegexInputValidation {\n        pattern\n      }\n    }\n  }\n\n  fragment PageParts on DirectFeedbackFormPage {\n    __typename\n    title\n    elements {\n      __typename\n      ... on EGDSElement {\n        egdsElementId\n      }\n      ... on DirectFeedbackInputField {\n        ...InputFieldParts\n      }\n      ... on DirectFeedbackTextArea {\n        ...InputFieldParts\n      }\n      ... on DirectFeedbackMultiSelectGroup {\n        ...DirectFeedbackMultiSelectGroupFragment\n      }\n      ... on EGDSPlainText {\n        text\n      }\n      ... on EGDSHeading {\n        text\n        headingType\n      }\n      ...SpannableTextContentsFragment\n    }\n    submitButton {\n      primary\n      egdsElementId\n    }\n    displayCondition {\n      fieldId\n      expectedValue\n    }\n  }\n\n  fragment DirectFeedbackMultiSelectGroupFragment on DirectFeedbackMultiSelectGroup {\n    groupName\n    required\n    errorMessage\n    options {\n      label {\n        text\n      }\n      name\n    }\n  }\n\n  ", "\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment ContentDirectFeedbackPromptFragment on DirectFeedbackPrompt {\n    title\n    pages {\n      ...PageParts\n    }\n  }\n\n  ", "\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  mutation ContentDirectFeedbackSubmit($context: ContextInput!, $id: ID!, $feedback: DirectFeedbackValuesInput!) {\n    directFeedbackSubmit(context: $context, id: $id, feedback: $feedback) {\n      errors {\n        fieldId\n        error\n      }\n    }\n  }\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  query ContentDirectFeedbackPromptQuery($context: ContextInput!, $id: ID!) {\n    directFeedbackPromptById(context: $context, id: $id) {\n      callToAction {\n        egdsElementId\n        icon {\n          id\n          size\n        }\n        primary\n      }\n      ...ContentDirectFeedbackPromptFragment\n    }\n  }\n  ", "\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment EmptyStateFragment on UIEmptyState {\n    heading\n    body\n  }\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment MessagingCardFragment on UIMessagingCard {\n    graphic {\n      __typename\n      ... on Icon {\n        id\n        description\n      }\n    }\n    primary\n    secondaries\n  }\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment NoResultsMessageFragment on PropertyReviews {\n    noResultsMessage {\n      __typename\n      ...MessagingCardFragment\n      ...EmptyStateFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment ReviewChildFragment on ManagementResponse {\n    id\n    header {\n      text\n    }\n    response\n  }\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment FeedbackIndicatorFragment on PropertyReview {\n    reviewInteractionSections {\n      primaryDisplayString\n      accessibilityLabel\n      reviewInteractionType\n      feedbackAnalytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  mutation UpvotePropertyReviewWithAccessibility($context: ContextInput!, $reviewId: String!, $index: Int!) {\n    upvotePropertyReviewWithAccessibility(context: $context, reviewId: $reviewId, index: $index) {\n      primaryDisplayString\n      accessibilityLabel\n    }\n  }\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  fragment PhotosFragment on PropertyReview {\n    id\n    photoSection {\n      imageClickAnalytics {\n        referrerId\n        linkName\n      }\n      exitAnalytics {\n        referrerId\n        linkName\n      }\n      navClickAnalytics {\n        referrerId\n        linkName\n      }\n      intersectionAnalytics {\n        referrerId\n        linkName\n      }\n    }\n    photos {\n      description\n      url\n    }\n  }\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  fragment AuthorFragment on PropertyReview {\n    reviewAuthorAttribution {\n      text\n    }\n  }\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject13() {
  var data = _tagged_template_literal(["\n  fragment PropertyReviewFooterSectionFragment on PropertyReviewFooterSection {\n    messages {\n      seoStructuredData {\n        itemscope\n        itemprop\n        itemtype\n        content\n      }\n      text {\n        ... on EGDSPlainText {\n          text\n        }\n        ... on EGDSGraphicText {\n          text\n          graphic {\n            ... on Mark {\n              description\n              id\n              size\n              url {\n                ... on HttpURI {\n                  relativePath\n                  value\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"]);
  _templateObject13 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject14() {
  var data = _tagged_template_literal(["\n  fragment PropertyReviewRegionFragment on PropertyReview {\n    reviewRegion {\n      id\n    }\n  }\n"]);
  _templateObject14 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject15() {
  var data = _tagged_template_literal(["\n  fragment PropertyReviewSourceFragment on PropertyReview {\n    propertyReviewSource {\n      accessibilityLabel\n      graphic {\n        description\n        id\n        size\n        token\n        url {\n          value\n        }\n      }\n      text {\n        value\n      }\n    }\n  }\n"]);
  _templateObject15 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject16() {
  var data = _tagged_template_literal(["\n  fragment ReviewThemeFragment on ReviewThemes {\n    icon {\n      id\n    }\n    label\n  }\n"]);
  _templateObject16 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject17() {
  var data = _tagged_template_literal(["\n  fragment ReviewTranslationInfoFragment on PropertyReview {\n    translationInfo {\n      loadingTranslationText\n      targetLocale\n      translatedBy {\n        description\n      }\n      translationCallToActionLabel\n      seeOriginalText\n    }\n  }\n"]);
  _templateObject17 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject18() {
  var data = _tagged_template_literal(["\n  fragment TravelersFragment on PropertyReview {\n    travelers\n  }\n"]);
  _templateObject18 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject19() {
  var data = _tagged_template_literal(["\n  fragment ReviewParentFragment on PropertyReview {\n    id\n    superlative\n    locale\n    title\n    brandType\n    disclaimer\n    reviewScoreWithDescription {\n      label\n      value\n    }\n    text\n    highlightedText {\n      ...EGDSSpannableTextFragment\n    }\n    seeMoreAnalytics {\n      linkName\n      referrerId\n    }\n    submissionTime {\n      longDateFormat\n    }\n    impressionAnalytics {\n      event\n      referrerId\n    }\n    themes {\n      ...ReviewThemeFragment\n    }\n    reviewFooter {\n      ...PropertyReviewFooterSectionFragment\n    }\n    reviewAnalytics\n    ...FeedbackIndicatorFragment\n    ...AuthorFragment\n    ...PhotosFragment\n    ...TravelersFragment\n    ...ReviewTranslationInfoFragment\n    ...PropertyReviewSourceFragment\n    ...PropertyReviewRegionFragment\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject19 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject20() {
  var data = _tagged_template_literal(["\n  query TranslateReviewQuery($context: ContextInput!, $propertyId: String!, $locale: Locale!, $reviewId: String!) {\n    propertyInfo(context: $context, propertyId: $propertyId) {\n      id\n      review(id: $reviewId, locale: $locale) {\n        translatedReviewId: id\n        translatedLocale: locale\n        translatedTitle: title\n        translatedText: text\n        translatedHighlightedText: highlightedText {\n          ...EGDSSpannableTextFragment\n        }\n      }\n    }\n  }\n  ", "\n"]);
  _templateObject20 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject21() {
  var data = _tagged_template_literal(["\n  fragment __PropertyReviewsListFragment on PropertyReviews {\n    summary {\n      paginateAction {\n        text\n        analytics {\n          referrerId\n          linkName\n        }\n      }\n    }\n    reviews {\n      contentDirectFeedbackPromptId\n      ...ReviewParentFragment\n      managementResponses {\n        ...ReviewChildFragment\n      }\n      reviewInteractionSections {\n        primaryDisplayString\n        reviewInteractionType\n      }\n    }\n    impressionAnalytics\n    ...NoResultsMessageFragment\n  }\n  ", "\n  ", "\n  ", ",\n"]);
  _templateObject21 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject22() {
  var data = _tagged_template_literal(["\n  query ReviewsQuery($context: ContextInput!, $propertyId: String!, $searchCriteria: PropertySearchCriteriaInput!) {\n    propertyInfo(propertyId: $propertyId, context: $context) {\n      id\n      reviewInfo(searchCriteria: $searchCriteria) {\n        ...__PropertyReviewsListFragment\n      }\n    }\n  }\n  ", "\n"]);
  _templateObject22 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject23() {
  var data = _tagged_template_literal(["\n  fragment __PropertyReviewSummaryFragment on PropertyReviewSummary {\n    accessibilityLabel\n    overallScoreWithDescriptionA11y {\n      ...LodgingEnrichedMessageFragment\n    }\n    propertyReviewCountDetails {\n      fullDescription\n    }\n    ...ReviewDisclaimerFragment\n    reviewSummaryDetails {\n      label\n      ratingPercentage\n      formattedRatingOutOfMax\n    }\n    totalCount {\n      raw\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject23 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject24() {
  var data = _tagged_template_literal(["\n  query PropertyReviewSummaries($context: ContextInput!, $propertyIds: [String!]!) {\n    propertyReviewSummaries(context: $context, propertyIds: $propertyIds) {\n      ...__PropertyReviewSummaryFragment\n    }\n  }\n  ", "\n"]);
  _templateObject24 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject25() {
  var data = _tagged_template_literal(["\n  query PropertyReviewAggregates($propertyIds: [String!]!, $context: ContextInput!) {\n    propertyReviewAggregates(propertyIds: $propertyIds, context: $context) {\n      propertySentiment {\n        text\n        subtext\n      }\n    }\n  }\n"]);
  _templateObject25 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject26() {
  var data = _tagged_template_literal(["\n  query PropertyReviewSummariesLine($context: ContextInput!, $propertyIds: [String!]!) {\n    propertyReviewSummaries(context: $context, propertyIds: $propertyIds) {\n      overallScoreWithDescription\n      propertyReviewCountDetails {\n        fullDescription\n      }\n      reviewDisclaimer\n      reviewDisclaimerAccessibilityLabel\n      totalCount {\n        raw\n      }\n    }\n  }\n"]);
  _templateObject26 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject27() {
  var data = _tagged_template_literal(["\n  fragment PopularMentionsFragment on SortAndFilterViewModel {\n    sortAndFilter {\n      title\n      placeholder\n      label\n      name\n      showListOptions {\n        seeLessLabel\n        seeMoreLabel\n      }\n      options {\n        ariaLabel\n        clickAnalytics {\n          referrerId\n          linkName\n        }\n        optionValue\n        label\n        isSelected\n      }\n      clickAnalytics {\n        referrerId\n        linkName\n      }\n    }\n  }\n"]);
  _templateObject27 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject28() {
  var data = _tagged_template_literal(["\n  fragment SearchTextFragment on SortAndFilterViewModel {\n    sortAndFilter {\n      name\n      label\n      graphic {\n        ...SearchTextIconFragment\n      }\n      submittedAnalytics\n      initiatedAnalytics\n    }\n  }\n\n  fragment SearchTextIconFragment on Icon {\n    description\n    id\n    token\n  }\n"]);
  _templateObject28 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject29() {
  var data = _tagged_template_literal(["\n  fragment SortTypeFragment on SortAndFilterViewModel {\n    sortAndFilter {\n      name\n      label\n      clickAnalytics {\n        linkName\n        referrerId\n      }\n      options {\n        label\n        isSelected\n        optionValue\n        description\n        clickAnalytics {\n          linkName\n          referrerId\n        }\n      }\n    }\n  }\n"]);
  _templateObject29 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject30() {
  var data = _tagged_template_literal(["\n  fragment TravelerTypeFragment on SortAndFilterViewModel {\n    sortAndFilter {\n      name\n      label\n      clickAnalytics {\n        linkName\n        referrerId\n      }\n      options {\n        label\n        isSelected\n        optionValue\n        description\n        clickAnalytics {\n          linkName\n          referrerId\n        }\n      }\n    }\n  }\n"]);
  _templateObject30 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject31() {
  var data = _tagged_template_literal(["\n  query PropertyFilteredReviewsQuery($context: ContextInput!, $propertyId: String!, $searchCriteria: PropertySearchCriteriaInput!) {\n    propertyReviewSummaries(context: $context, propertyIds: [$propertyId], searchCriteria: $searchCriteria) {\n      ...__PropertyReviewSummaryFragment\n    }\n    propertyInfo(context: $context, propertyId: $propertyId) {\n      id\n      reviewInfo(searchCriteria: $searchCriteria) {\n        ...__PropertyReviewsListFragment\n        sortAndFilter {\n          ...TravelerTypeFragment\n          ...SortTypeFragment\n          ...SearchTextFragment\n          ...PopularMentionsFragment\n        }\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject31 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject32() {
  var data = _tagged_template_literal(["\n  query PropertyReviewsBreakdownQuery($context: ContextInput!, $propertyIds: [String!]!) {\n    propertyReviewSummaries(context: $context, propertyIds: $propertyIds) {\n      ...PropertyReviewsBreakdownFragment\n    }\n  }\n  ", "\n"]);
  _templateObject32 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject33() {
  var data = _tagged_template_literal(["\n  query PropertyReviewsQuery($context: ContextInput!, $propertyId: String!, $searchCriteria: PropertySearchCriteriaInput!) {\n    propertyInfo(context: $context, propertyId: $propertyId) {\n      id\n      reviewInfo(searchCriteria: $searchCriteria) {\n        summary {\n          seeAllReviewsCallToActionLabel\n          accessibilityLabel\n          strategy\n          ...PropertyReviewsBreakdownFragment\n        }\n        ...__PropertyReviewsListFragment\n      }\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject33 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject34() {
  var data = _tagged_template_literal(["\n  query PropertyRoomScoresQuery($propertyIds: [String!]!, $context: ContextInput!, $withTags: Boolean!) {\n    propertyReviewAggregates(propertyIds: $propertyIds, context: $context) {\n      ...PropertyReviewAggregatesFragment\n    }\n  }\n\n  fragment PropertyReviewAggregatesFragment on PropertyReviewAggregates {\n    propertySummaries {\n      propertyId\n      roomsScore {\n        ...RoomSummaryFragment\n      }\n    }\n  }\n\n  fragment RoomSummaryFragment on RoomSummary {\n    scoreLabel\n    id\n    roomRatingListTitle @include(if: $withTags)\n    tags @include(if: $withTags) {\n      label\n    }\n  }\n"]);
  _templateObject34 = function _templateObject() {
    return data;
  };
  return data;
}
import React20 from "react";
import { gql as gql20, useQuery as useQuery2 } from "@apollo/client";
import { useBexApi as useBexApi5 } from "@shared-ui/bex-api-context";
// src/utils/merge-search-criteria.ts
var mergeFilters = function (currentFilterList, newFilterList) {
  if (!currentFilterList || !newFilterList) {
    return currentFilterList;
  }
  return _to_consumable_array(newFilterList).concat(_to_consumable_array(currentFilterList.filter(function (param) {
    var oldId = param.id;
    return !newFilterList.some(function (filter) {
      return oldId === (filter === null || filter === void 0 ? void 0 : filter.id);
    });
  })));
};
var mergeSearchCriteria = function (currentSearchCriteria, newSearchCriteria) {
  var _currentSearchCriteria_secondary, _newSearchCriteria_secondary, _currentSearchCriteria_secondary1, _newSearchCriteria_secondary1, _currentSearchCriteria_secondary2, _newSearchCriteria_secondary2, _currentSearchCriteria_secondary3, _newSearchCriteria_secondary3, _currentSearchCriteria_secondary4, _newSearchCriteria_secondary4;
  if (!currentSearchCriteria || !newSearchCriteria) {
    return currentSearchCriteria;
  }
  return _object_spread_props(_object_spread({}, currentSearchCriteria, newSearchCriteria), {
    secondary: {
      booleans: mergeFilters((_currentSearchCriteria_secondary = currentSearchCriteria.secondary) === null || _currentSearchCriteria_secondary === void 0 ? void 0 : _currentSearchCriteria_secondary.booleans, (_newSearchCriteria_secondary = newSearchCriteria.secondary) === null || _newSearchCriteria_secondary === void 0 ? void 0 : _newSearchCriteria_secondary.booleans),
      counts: mergeFilters((_currentSearchCriteria_secondary1 = currentSearchCriteria.secondary) === null || _currentSearchCriteria_secondary1 === void 0 ? void 0 : _currentSearchCriteria_secondary1.counts, (_newSearchCriteria_secondary1 = newSearchCriteria.secondary) === null || _newSearchCriteria_secondary1 === void 0 ? void 0 : _newSearchCriteria_secondary1.counts),
      dates: mergeFilters((_currentSearchCriteria_secondary2 = currentSearchCriteria.secondary) === null || _currentSearchCriteria_secondary2 === void 0 ? void 0 : _currentSearchCriteria_secondary2.dates, (_newSearchCriteria_secondary2 = newSearchCriteria.secondary) === null || _newSearchCriteria_secondary2 === void 0 ? void 0 : _newSearchCriteria_secondary2.dates),
      ranges: mergeFilters((_currentSearchCriteria_secondary3 = currentSearchCriteria.secondary) === null || _currentSearchCriteria_secondary3 === void 0 ? void 0 : _currentSearchCriteria_secondary3.ranges, (_newSearchCriteria_secondary3 = newSearchCriteria.secondary) === null || _newSearchCriteria_secondary3 === void 0 ? void 0 : _newSearchCriteria_secondary3.ranges),
      selections: mergeFilters((_currentSearchCriteria_secondary4 = currentSearchCriteria.secondary) === null || _currentSearchCriteria_secondary4 === void 0 ? void 0 : _currentSearchCriteria_secondary4.selections, (_newSearchCriteria_secondary4 = newSearchCriteria.secondary) === null || _newSearchCriteria_secondary4 === void 0 ? void 0 : _newSearchCriteria_secondary4.selections)
    }
  });
};
var merge_search_criteria_default = mergeSearchCriteria;
// src/utils/build-fetch-more-reviews.ts
var buildFetchMoreReviews = function (fetchMore, currentVariables) {
  return function (param) {
    var updateQuery = param.updateQuery,
      newVariables = param.variables;
    fetchMore({
      updateQuery: updateQuery,
      variables: _object_spread_props(_object_spread({}, currentVariables, newVariables), {
        searchCriteria: merge_search_criteria_default(currentVariables.searchCriteria, newVariables.searchCriteria)
      })
    });
  };
};
// src/components/__private/__fragments/property-reviews-list.tsx
import React19, { useRef } from "react";
import { useApolloClient } from "@apollo/client";
import { EGDSSecondaryButton } from "@egds/react-core/button";
import { EGDSCard as EGDSCard2, EGDSCardContentSection } from "@egds/react-core/cards";
import { EGDSSpacing as EGDSSpacing13 } from "@egds/react-core/spacing";
import { EgClickstreamImpressionTracker as EgClickstreamImpressionTracker2, useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
// src/utils/index.ts
import { useCallback, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
function useQueryParams() {
  var location = useLocation();
  var searchParams = useMemo(function () {
    return new URLSearchParams(location.search);
  }, [location.search]);
  return searchParams;
}
function useDeleteParam() {
  var history = useHistory();
  return useCallback(function (key) {
    var params = new URLSearchParams(history.location.search);
    params.delete(key);
    history.replace("".concat(history.location.pathname, "?").concat(params));
  }, [history]);
}
// src/components/__private/analytics.ts
var UPVOTE_TRACKER = {
  link: "upvote a review",
  rfrr: "HOT.HIS.REVIEW.THUMB_UP.UPVOTE"
};
var TRANSLATE_TRACKER = {
  link: "Google translated review",
  rfrr: "HOT.HIS.Reviews.GoogleTranslate"
};
var DISCLAIMER_DIALOG_TRACKER = {
  rfrr: "HOT.HIS.Reviews.DisclaimerDialog",
  link: "Review Disclaimer Dialog"
};
var SEE_ALL_REVIEWS_TRACKER = {
  rfrr: "HOT.HIS.Reviews.ClickSeeAllReviewsToOpenDialog",
  link: "See All Reviews"
};
// src/components/__private/defaults.ts
var DEFAULT_STARTING_INDEX = 0;
var DEFAULT_PAGINATION_SIZE = 10;
var DEFAULT_REVIEWS_SORT = "NEWEST_TO_OLDEST_BY_LANGUAGE";
var DEFAULT_SEARCH_INPUT = "";
var DEFAULT_POPULAR_MENTION_INPUT = "";
var DEFAULT_PAGINATION_SIZE_PROGRESSIVE_DISCLOSURE = 2;
var POPULAR_MENTION_FILTER_NAME = "popularMentions";
var DEFAULT_POPULAR_MENTIONS_VIEW_IN = 9;
var DEFAULT_TRAVELER_TYPE = "all";
var EVENT_VERSION = "1.0.0";
var EVENT_TYPE = "Impression";
var buildClientEvent = function (eventName, eventVersion) {
  var actionLocation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  return {
    event: {
      event_name: eventName,
      event_version: eventVersion,
      action_location: actionLocation
    }
  };
};
var buildReviewsEvent = function (eventName, eventVersion, eventType) {
  var actionLocation = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
  return {
    event: {
      event_name: eventName,
      event_type: eventType,
      event_version: eventVersion,
      action_location: actionLocation
    },
    experience: {
      app_name: "shared-ui",
      app_version: "1.0.0",
      page_name: "PDP Page"
    }
  };
};
// src/components/__private/__fragments/content-direct-feedback/content-direct-feedback-call-to-action.tsx
import React4, { useState as useState3 } from "react";
import { gql as gql4, useQuery } from "@apollo/client";
import { EGDSIcon as EGDSIcon2, EGDSIconSize as EGDSIconSize2 } from "@egds/react-core/icons";
import { EGDSLink as EGDSLink2 } from "@egds/react-core/link";
import { EGDSSheetTransition } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText3 } from "@egds/react-core/text";
import { EGDSToast } from "@egds/react-core/toast";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
// src/components/__private/__fragments/content-direct-feedback/analytics-tracking.ts
var REPORT_REVIEW_DIALOG_TRACKER = {
  rfrr: "HOT.HIS.REVIEW.Report.FlagOpenDialog",
  link: "Report Review Dialog"
};
var REPORT_REVIEW_PARTNER_FORM = {
  rfrr: "HOT.HIS.REVIEW.Report.OpenPartnerDisputeForm",
  link: "Report Review Partner Dispute Form"
};
var REPORT_REVIEW_SUBMIT_FORM = {
  rfrr: "HOT.HIS.REVIEW.Report.Submit",
  link: "Report Review Partner Submit Form"
};
var reportReviewOptionsTracking = function (option) {
  return {
    rfrr: "HOT.HIS.REVIEW.Report.".concat(option),
    // I think using the option instead of the mapping would be more readable but this is the existing behavior
    link: "Review report reason is ".concat(option)
  };
};
// src/components/__private/__fragments/content-direct-feedback/content-direct-feedback-prompt.tsx
import React3, { useState as useState2 } from "react";
import { gql as gql3, useMutation } from "@apollo/client";
import { EGDSDialogContent } from "@egds/react-core/dialog";
import { EGDSSheet } from "@egds/react-core/sheet";
import { EGDSToolbar } from "@egds/react-core/toolbar";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { useLocalization } from "@shared-ui/localization-context";
// src/components/__private/__fragments/content-direct-feedback/content-direct-feedback-prompt-page.tsx
import React2, { useState } from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSButtonSize, EGDSPrimaryButton } from "@egds/react-core/button";
import { EGDSCheckbox } from "@egds/react-core/checkbox";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSText as EGDSText2 } from "@egds/react-core/text";
// src/components/__private/__fragments/content-direct-feedback/content-direct-feedback-prompt-spannable-text.tsx
import React from "react";
import { gql } from "@apollo/client";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSText } from "@egds/react-core/text";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
var fragment = gql(_templateObject());
var SpannableTextContents = function (param) {
  var content = param.content;
  var track = useClickTracker();
  var trackPartnerForm = function () {
    return track(REPORT_REVIEW_PARTNER_FORM.rfrr, REPORT_REVIEW_PARTNER_FORM.link);
  };
  switch (content.__typename) {
    case "EGDSPlainText":
      return /* @__PURE__ */React.createElement(React.Fragment, null, content.text);
    case "EGDSInlineLink":
      {
        var resourceType = content.action.resource.__typename;
        return resourceType === "HttpURI" ? /* @__PURE__ */React.createElement(EGDSLink, {
          inline: true,
          size: content.size.toLowerCase()
        }, /* @__PURE__ */React.createElement("a", {
          target: "_blank",
          href: content.action.resource.value,
          onClick: trackPartnerForm,
          rel: "noreferrer"
        }, content.text)) : null;
      }
    case "EGDSStandardLink":
      {
        var _content_icon, _content_icon1, _content_icon2, _content_icon3;
        var resourceType1 = content.action.resource.__typename;
        return resourceType1 === "HttpURI" ? /* @__PURE__ */React.createElement(EGDSLink, {
          inline: true,
          size: content.size.toLowerCase()
        }, /* @__PURE__ */React.createElement("a", {
          target: "_blank",
          href: content.action.resource.value,
          onClick: trackPartnerForm,
          rel: "noreferrer"
        }, content.text, /* @__PURE__ */React.createElement(EGDSSpacing, {
          margin: {
            blockend: "half"
          }
        }, /* @__PURE__ */React.createElement(EGDSIcon, {
          id: ((_content_icon = content.icon) === null || _content_icon === void 0 ? void 0 : _content_icon.id) || "",
          name: ((_content_icon1 = content.icon) === null || _content_icon1 === void 0 ? void 0 : _content_icon1.id) || "",
          size: ((_content_icon2 = content.icon) === null || _content_icon2 === void 0 ? void 0 : _content_icon2.size) && EGDSIconSize[content.icon.size],
          title: (_content_icon3 = content.icon) === null || _content_icon3 === void 0 ? void 0 : _content_icon3.description
        })))) : null;
      }
    default:
      return null;
  }
};
var SpannableText = function (param) {
  var data = param.data;
  return /* @__PURE__ */React.createElement(EGDSText, {
    size: 300,
    spacing: "two"
  }, data.contents.map(function (content, index) {
    return /* @__PURE__ */React.createElement(SpannableTextContents, {
      key: "".concat(content.__typename, "-").concat(index),
      content: content
    });
  }));
};
SpannableText.displayName = "SpannableText";
SpannableText.fragment = fragment;
// src/components/__private/__fragments/content-direct-feedback/content-direct-feedback-prompt-page.tsx
var fragment2 = gql2(_templateObject1(), SpannableText.fragment);
var ContentDirectFeedbackPromptPage = function (param) {
  var data = param.data,
    handleSubmit = param.handleSubmit,
    loading = param.loading,
    reportStateUpdatetoParent = param.reportStateUpdatetoParent;
  var _useState = _sliced_to_array(useState({}), 2),
    checkboxSelectedMap = _useState[0],
    setCheckboxSelectedMap = _useState[1];
  var handleCheckboxChange = function (event) {
    var nextState = _object_spread_props(_object_spread({}, checkboxSelectedMap), _define_property({}, event.currentTarget.value, event.currentTarget.checked));
    setCheckboxSelectedMap(nextState);
    reportStateUpdatetoParent(nextState);
  };
  var checkboxesElement = data.elements.find(function (el) {
    return el.__typename === "DirectFeedbackMultiSelectGroup";
  });
  var isAnyCheckboxSelectedRequired = !!(checkboxesElement === null || checkboxesElement === void 0 ? void 0 : checkboxesElement.required);
  var isAnyCheckboxSelected = Object.keys(checkboxSelectedMap).some(function (key) {
    return checkboxSelectedMap[key];
  });
  var isSubmitDisabled = loading || isAnyCheckboxSelectedRequired && !isAnyCheckboxSelected;
  return /* @__PURE__ */React2.createElement(React2.Fragment, null, data.elements.map(function (element, index) {
    switch (element.__typename) {
      case "EGDSPlainText":
        return /* @__PURE__ */React2.createElement(EGDSSpacing2, {
          key: "".concat(element.__typename, "-").concat(index),
          margin: {
            blockstart: "six",
            blockend: "two"
          }
        }, /* @__PURE__ */React2.createElement(EGDSText2, {
          size: 300,
          spacing: "two"
        }, element.text));
      case "EGDSSpannableText":
        return /* @__PURE__ */React2.createElement(EGDSSpacing2, {
          key: "".concat(element.__typename, "-").concat(index),
          margin: {
            blockstart: "six",
            blockend: "two"
          }
        }, /* @__PURE__ */React2.createElement(SpannableText, {
          data: element
        }));
      case "EGDSHeading":
        var _element_headingType;
        return /* @__PURE__ */React2.createElement(EGDSSpacing2, {
          key: "".concat(element.__typename, "-").concat(index),
          margin: {
            blockstart: "three",
            blockend: "two"
          }
        }, /* @__PURE__ */React2.createElement(EGDSHeading, {
          tag: (_element_headingType = element.headingType) === null || _element_headingType === void 0 ? void 0 : _element_headingType.toLowerCase(),
          size: 5
        }, element.text));
      case "DirectFeedbackMultiSelectGroup":
        return /* @__PURE__ */React2.createElement(React2.Fragment, {
          key: "".concat(element.__typename, "-").concat(index)
        }, element.options.map(function (option, optionIndex) {
          var text = option.label.text,
            optionValue = option.name;
          return /* @__PURE__ */React2.createElement(EGDSCheckbox, {
            id: "".concat(text, "-").concat(optionValue),
            key: "".concat(option.__typename, "-").concat(optionIndex),
            onChange: handleCheckboxChange,
            value: optionValue || "",
            checked: checkboxSelectedMap[optionValue || ""]
          }, text);
        }));
      default:
        return null;
    }
  }), /* @__PURE__ */React2.createElement(EGDSSpacing2, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React2.createElement("div", null, /* @__PURE__ */React2.createElement(EGDSPrimaryButton, {
    disabled: isSubmitDisabled,
    onClick: handleSubmit,
    size: EGDSButtonSize.SMALL
  }, data.submitButton.primary))));
};
ContentDirectFeedbackPromptPage.displayName = "ContentDirectFeedbackPromptPage";
ContentDirectFeedbackPromptPage.fragment = fragment2;
// src/components/__private/__fragments/content-direct-feedback/content-direct-feedback-prompt.tsx
var fragment3 = gql3(_templateObject2(), ContentDirectFeedbackPromptPage.fragment);
var mutation = gql3(_templateObject3());
var getMutationFeedback = function (feedbackContext, checkboxState) {
  var transformMapToMultiselect = function (map) {
    return {
      key: "report_category",
      value: Object.keys(map).filter(function (key) {
        return map[key];
      }).join(",")
    };
  };
  return {
    context: feedbackContext,
    formValues: [
    // TODO: dynamically build this array from prompt data
    transformMapToMultiselect(checkboxState)]
  };
};
var ContentDirectFeedbackPrompt = function (param) {
  var closeReportDialog = param.closeReportDialog,
    data = param.data,
    feedbackContext = param.feedbackContext,
    handleShowToast = param.handleShowToast,
    hideReview = param.hideReview,
    inputs = param.inputs,
    triggerRef = param.triggerRef;
  var formatText = useLocalization().formatText;
  var _useMutation = _sliced_to_array(useMutation(mutation), 2),
    fireCDFMutation = _useMutation[0],
    loading = _useMutation[1].loading;
  var context = useBexApi().context;
  var _useState2 = _sliced_to_array(useState2({}), 2),
    childCheckboxSelectedMap = _useState2[0],
    setChildCheckboxSelectedMap = _useState2[1];
  var track = useClickTracker2();
  var validatedPromptTitle = data.title || "Report review";
  var validatedPromptIconLabel = formatText("close.dialog");
  var firstPage = data.pages[0];
  if (!firstPage) {
    return null;
  }
  var handleChildStateUpdate = function (nextState) {
    setChildCheckboxSelectedMap(nextState);
  };
  var handleSubmit = function () {
    if (loading) {
      return;
    }
    var feedback = getMutationFeedback(feedbackContext, childCheckboxSelectedMap);
    fireCDFMutation({
      variables: {
        context: context,
        feedback: feedback,
        id: inputs === null || inputs === void 0 ? void 0 : inputs.id
      }
    });
    hideReview();
    var selectedOptions = Object.entries(childCheckboxSelectedMap).filter(function (param) {
      var _param = _sliced_to_array(param, 2),
        _ = _param[0],
        value = _param[1];
      return value;
    });
    selectedOptions.forEach(function (selectedOption) {
      var _selectedOption = _sliced_to_array(selectedOption, 2),
        key = _selectedOption[0],
        _ = _selectedOption[1];
      var _reportReviewOptionsTracking = reportReviewOptionsTracking(key),
        rfrr = _reportReviewOptionsTracking.rfrr,
        link = _reportReviewOptionsTracking.link;
      track(rfrr, link, true);
    });
    track(REPORT_REVIEW_SUBMIT_FORM.rfrr, REPORT_REVIEW_SUBMIT_FORM.link, true);
    closeReportDialog();
    handleShowToast();
  };
  return /* @__PURE__ */React3.createElement(EGDSSheet, {
    type: "centered",
    isVisible: true,
    triggerRef: triggerRef
  }, /* @__PURE__ */React3.createElement(EGDSToolbar, {
    toolbarTitle: validatedPromptTitle,
    navigationContent: {
      onClick: closeReportDialog,
      navIconLabel: validatedPromptIconLabel,
      navType: "close"
    }
  }), /* @__PURE__ */React3.createElement(EGDSDialogContent, null, /* @__PURE__ */React3.createElement(ContentDirectFeedbackPromptPage, {
    data: firstPage,
    handleSubmit: handleSubmit,
    loading: loading,
    reportStateUpdatetoParent: handleChildStateUpdate
  })));
};
ContentDirectFeedbackPrompt.displayName = "ContentDirectFeedbackPrompt";
ContentDirectFeedbackPrompt.fragment = fragment3;
// src/components/__private/__fragments/content-direct-feedback/content-direct-feedback-call-to-action.tsx
var query = gql4(_templateObject4(), ContentDirectFeedbackPrompt.fragment);
var ContentDirectFeedbackCallToAction = function (props) {
  var _prompt_callToAction, _prompt_callToAction1;
  var dialogId = props.dialogId,
    id = props.inputs.id;
  var context = useBexApi2().context;
  var _useQuery = useQuery(query, {
      variables: {
        id: id,
        context: context
      }
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  var _useState3 = _sliced_to_array(useState3(false), 2),
    showToast = _useState3[0],
    setShowToast = _useState3[1];
  var _useDialog = _sliced_to_array(useDialog("content-direct-feedback-dialog-".concat(dialogId), "pwaDialogNested"), 3),
    isDialogOpen = _useDialog[0],
    dialogActions = _useDialog[1],
    DialogComponent = _useDialog[2];
  var track = useClickTracker3();
  var triggerRef = React4.useRef(null);
  var prompt = data === null || data === void 0 ? void 0 : data.directFeedbackPromptById;
  if (error || loading || !prompt) {
    return null;
  }
  var openDialog = dialogActions.openDialog,
    closeDialog = dialogActions.closeDialog;
  var ctaText = (_prompt_callToAction = prompt.callToAction) === null || _prompt_callToAction === void 0 ? void 0 : _prompt_callToAction.primary;
  var ctaIcon = (_prompt_callToAction1 = prompt.callToAction) === null || _prompt_callToAction1 === void 0 ? void 0 : _prompt_callToAction1.icon;
  var lastPage = prompt === null || prompt === void 0 ? void 0 : prompt.pages[1];
  var toast = lastPage === null || lastPage === void 0 ? void 0 : lastPage.elements.find(function (el) {
    return el.__typename === "EGDSPlainText";
  });
  var handleCtaOnClick = function () {
    track(REPORT_REVIEW_DIALOG_TRACKER.rfrr, REPORT_REVIEW_DIALOG_TRACKER.link);
    openDialog();
    setShowToast(false);
  };
  return /* @__PURE__ */React4.createElement(React4.Fragment, null, /* @__PURE__ */React4.createElement(EGDSLink2, {
    inline: true,
    onClick: handleCtaOnClick
  }, /* @__PURE__ */React4.createElement("button", {
    type: "button",
    ref: triggerRef
  }, /* @__PURE__ */React4.createElement(EGDSIcon2, {
    name: (ctaIcon === null || ctaIcon === void 0 ? void 0 : ctaIcon.id) || "",
    key: ctaIcon === null || ctaIcon === void 0 ? void 0 : ctaIcon.id,
    size: (ctaIcon === null || ctaIcon === void 0 ? void 0 : ctaIcon.size) && EGDSIconSize2[ctaIcon.size]
  }), /* @__PURE__ */React4.createElement(EGDSSpacing3, {
    padding: {
      inlinestart: "one"
    }
  }, /* @__PURE__ */React4.createElement(EGDSText3, {
    inline: true,
    size: 200
  }, ctaText)))), /* @__PURE__ */React4.createElement(EGDSSheetTransition, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React4.createElement(DialogComponent, null, /* @__PURE__ */React4.createElement(ContentDirectFeedbackPrompt, _object_spread_props(_object_spread({}, props), {
    closeReportDialog: closeDialog,
    data: prompt,
    handleShowToast: function () {
      return setShowToast(true);
    },
    triggerRef: triggerRef
  })))), toast && /* @__PURE__ */React4.createElement(EGDSToast, {
    show: showToast
  }, toast.text));
};
ContentDirectFeedbackCallToAction.displayName = "ContentDirectFeedbackCallToAction";
// src/components/__private/__fragments/no-results-message.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
// src/components/__private/__fragments/empty-state.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { EGDSEmptyState } from "@egds/react-core/empty-state";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading2, EGDSText as EGDSText4 } from "@egds/react-core/text";
var fragment4 = gql5(_templateObject5());
var EmptyState = function (param) {
  var data = param.data;
  var heading = data.heading,
    body = data.body;
  return /* @__PURE__ */React5.createElement(EGDSEmptyState, null, /* @__PURE__ */React5.createElement(EGDSSpacing4, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React5.createElement(EGDSHeading2, {
    size: 5,
    tag: "h3"
  }, heading)), /* @__PURE__ */React5.createElement(EGDSText4, {
    spacing: "two",
    size: 300
  }, body));
};
EmptyState.displayName = "EmptyState";
EmptyState.fragment = _object_spread_props(_object_spread({}, fragment4), {
  __typename: "UIEmptyState"
});
// src/components/__private/__fragments/messaging-card.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { EGDSCard } from "@egds/react-core/cards";
import { EGDSIcon as EGDSIcon3 } from "@egds/react-core/icons";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading3, EGDSText as EGDSText5 } from "@egds/react-core/text";
var fragment5 = gql6(_templateObject6());
var MessagingCard = function (param) {
  var data = param.data;
  var graphic = data.graphic,
    primary = data.primary,
    secondaries = data.secondaries;
  var icon = (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) === "Icon" && /* @__PURE__ */React6.createElement(EGDSIcon3, {
    name: graphic.id,
    id: graphic.id,
    description: graphic.description,
    spotlight: "info"
  });
  return /* @__PURE__ */React6.createElement(EGDSCard, {
    padded: true,
    border: true
  }, /* @__PURE__ */React6.createElement(EGDSLayoutFlex, {
    alignItems: "center",
    space: "two"
  }, /* @__PURE__ */React6.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React6.createElement("div", null, icon)), /* @__PURE__ */React6.createElement(EGDSSpacing5, {
    margin: {
      inlinestart: "two"
    }
  }, /* @__PURE__ */React6.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React6.createElement("div", null, primary && /* @__PURE__ */React6.createElement(EGDSHeading3, {
    tag: "h4"
  }, primary), /* @__PURE__ */React6.createElement(EGDSText5, {
    size: 300
  }, secondaries === null || secondaries === void 0 ? void 0 : secondaries[0]))))));
};
MessagingCard.displayName = "MessagingCard";
MessagingCard.fragment = _object_spread_props(_object_spread({}, fragment5), {
  __typename: "UIMessagingCard"
});
// src/components/__private/__fragments/no-results-message.tsx
var fragment6 = gql7(_templateObject7(), MessagingCard.fragment, EmptyState.fragment);
var NoResultsMessage = function (param) {
  var data = param.data;
  var noResultsMessage = data.noResultsMessage;
  if (!noResultsMessage) {
    return null;
  }
  var component;
  if (noResultsMessage.__typename === MessagingCard.fragment.__typename) {
    component = /* @__PURE__ */React7.createElement(MessagingCard, {
      data: noResultsMessage
    });
  } else if (noResultsMessage.__typename === EmptyState.fragment.__typename) {
    component = /* @__PURE__ */React7.createElement(EmptyState, {
      data: noResultsMessage
    });
  }
  return component;
};
NoResultsMessage.fragment = fragment6;
NoResultsMessage.displayName = "NoResultsMessage";
// src/components/__private/__fragments/property-reviews-list-fragment.ts
import { gql as gql19 } from "@apollo/client";
// src/components/__private/__fragments/review-child.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing6 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText6 } from "@egds/react-core/text";
var fragment7 = gql8(_templateObject8());
var ReviewChild = function (param) {
  var data = param.data;
  var id = data.id,
    header = data.header,
    response = data.response;
  if (!id || !response) {
    return null;
  }
  return /* @__PURE__ */React8.createElement(EGDSSpacing6, {
    border: ["inlinestart"],
    padding: {
      inlinestart: "three"
    },
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React8.createElement("article", {
    id: id
  }, /* @__PURE__ */React8.createElement("section", null, (header === null || header === void 0 ? void 0 : header.text) && /* @__PURE__ */React8.createElement(EGDSText6, {
    weight: "bold",
    size: 200
  }, header.text)), /* @__PURE__ */React8.createElement("section", null, /* @__PURE__ */React8.createElement(EGDSSpacing6, {
    padding: {
      block: "two"
    }
  }, /* @__PURE__ */React8.createElement(EGDSText6, {
    size: 200,
    theme: "standard"
  }, response)))));
};
ReviewChild.displayName = "ReviewChild";
ReviewChild.fragment = fragment7;
var review_child_default = ReviewChild;
// src/components/__private/__fragments/review-parent.tsx
import React18 from "react";
import { gql as gql18, useLazyQuery } from "@apollo/client";
import { EGDSExpandoPeek } from "@egds/react-core/expando";
import { EGDSLayoutFlex as EGDSLayoutFlex4, EGDSLayoutFlexItem as EGDSLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing12 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading6, EGDSText as EGDSText13 } from "@egds/react-core/text";
import { SearchHighlight } from "@egds/react-property-experience";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
import { EgClickstreamImpressionTracker, IntersectionTracker as IntersectionTracker2, useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
import { EGDSSpannableText } from "@shared-ui/lodging-fragments";
// src/components/__private/__fragments/feedback-indicator.tsx
import React9, { useEffect } from "react";
import { gql as gql9, useMutation as useMutation2 } from "@apollo/client";
import { EGDSIcon as EGDSIcon4, EGDSIconSize as EGDSIconSize3 } from "@egds/react-core/icons";
import { EGDSLink as EGDSLink3 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing7 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText7 } from "@egds/react-core/text";
import { Level, liveAnnounce } from "@egds/react-core/utils";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
var fragment8 = gql9(_templateObject9());
var MutationUpvotePropertyReviewWithAccessibility = gql9(_templateObject10());
var FeedbackIndicator = function (param) {
  var data = param.data,
    reviewId = param.reviewId,
    reviewIndex = param.reviewIndex,
    reviewsPage = param.reviewsPage;
  var _mutationStatus_data;
  var context = useBexApi3().context;
  var reviewInteractionSections = data.reviewInteractionSections;
  var _useMutation2 = _sliced_to_array(useMutation2(MutationUpvotePropertyReviewWithAccessibility), 2),
    upvoteMutation = _useMutation2[0],
    mutationStatus = _useMutation2[1];
  var tracker = useClickTracker4();
  var mutationData = mutationStatus === null || mutationStatus === void 0 ? void 0 : (_mutationStatus_data = mutationStatus.data) === null || _mutationStatus_data === void 0 ? void 0 : _mutationStatus_data.upvotePropertyReviewWithAccessibility;
  useEffect(function () {
    if (mutationData === null || mutationData === void 0 ? void 0 : mutationData.accessibilityLabel) {
      var _mutationData_accessibilityLabel;
      liveAnnounce((_mutationData_accessibilityLabel = mutationData === null || mutationData === void 0 ? void 0 : mutationData.accessibilityLabel) !== null && _mutationData_accessibilityLabel !== void 0 ? _mutationData_accessibilityLabel : "", Level.POLITE);
    }
  }, [mutationData]);
  if (!(reviewInteractionSections === null || reviewInteractionSections === void 0 ? void 0 : reviewInteractionSections.length)) {
    return null;
  }
  var feedbackIndicatorInteractionSection = reviewInteractionSections === null || reviewInteractionSections === void 0 ? void 0 : reviewInteractionSections.find(function (section) {
    return section.reviewInteractionType === "HELPFUL_REVIEW" /* HELPFUL_REVIEW */;
  });
  if (!feedbackIndicatorInteractionSection) {
    return null;
  }
  var primaryDisplayString = feedbackIndicatorInteractionSection.primaryDisplayString,
    accessibilityLabel = feedbackIndicatorInteractionSection.accessibilityLabel,
    feedbackAnalytics = feedbackIndicatorInteractionSection.feedbackAnalytics;
  var _mutationData_primaryDisplayString;
  var labelCount = (_mutationData_primaryDisplayString = mutationData === null || mutationData === void 0 ? void 0 : mutationData.primaryDisplayString) !== null && _mutationData_primaryDisplayString !== void 0 ? _mutationData_primaryDisplayString : primaryDisplayString;
  var _mutationData_accessibilityLabel;
  var label = (_mutationData_accessibilityLabel = mutationData === null || mutationData === void 0 ? void 0 : mutationData.accessibilityLabel) !== null && _mutationData_accessibilityLabel !== void 0 ? _mutationData_accessibilityLabel : accessibilityLabel;
  return /* @__PURE__ */React9.createElement(EGDSSpacing7, {
    padding: {
      inlineend: "one"
    }
  }, /* @__PURE__ */React9.createElement("div", {
    "data-stid": "property-review-feedback-indicator"
  }, /* @__PURE__ */React9.createElement(EGDSLink3, {
    disabled: mutationStatus === null || mutationStatus === void 0 ? void 0 : mutationStatus.called,
    onClick: function () {
      if (feedbackAnalytics && reviewsPage === "ReviewsOverlay" /* REVIEWS_OVERLAY */) {
        tracker(feedbackAnalytics.referrerId, feedbackAnalytics.linkName);
      } else {
        tracker(UPVOTE_TRACKER.rfrr, UPVOTE_TRACKER.link);
      }
      upvoteMutation({
        variables: {
          context: context,
          reviewId: reviewId,
          index: reviewIndex
        }
      });
    }
  }, /* @__PURE__ */React9.createElement("button", {
    "aria-label": label !== null && label !== void 0 ? label : "",
    type: "button"
  }, /* @__PURE__ */React9.createElement(EGDSIcon4, {
    name: "thumb_up",
    size: EGDSIconSize3.EXTRA_SMALL
  }), labelCount && /* @__PURE__ */React9.createElement(LabelCount, {
    count: labelCount
  })))));
};
var LabelCount = function (param) {
  var count = param.count;
  return /* @__PURE__ */React9.createElement(EGDSSpacing7, {
    padding: {
      inlinestart: "one"
    }
  }, /* @__PURE__ */React9.createElement(EGDSText7, {
    inline: true,
    size: 200
  }, count));
};
FeedbackIndicator.displayName = "FeedbackIndicator";
FeedbackIndicator.fragment = fragment8;
var feedback_indicator_default = FeedbackIndicator;
// src/components/__private/__fragments/photos.tsx
import React10 from "react";
import { gql as gql10 } from "@apollo/client";
import { EGDSButton } from "@egds/react-core/button";
import { EGDSFigure, EGDSFigureAspectRatioType, EGDSImage, EGDSImageLink } from "@egds/react-core/images";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { UitkMediaGalleryImageDialog as EGDSMediaGalleryImageDialog, UitkMediaGalleryImageView as EGDSMediaGalleryImageView } from "@egds/react-core/media-gallery";
import { EGDSSheetTransition as EGDSSheetTransition2 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing8 } from "@egds/react-core/spacing";
import { IntersectionTracker, useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
var __PhotosFragment = gql10(_templateObject11());
var Photos = function (param) {
  var data = param.data,
    reviewsPage = param.reviewsPage;
  var id = data.id,
    photos = data.photos,
    photoSection = data.photoSection;
  var _ref = photoSection || {},
    imageClickAnalytics = _ref.imageClickAnalytics,
    exitAnalytics = _ref.exitAnalytics,
    navClickAnalytics = _ref.navClickAnalytics,
    intersectionAnalytics = _ref.intersectionAnalytics;
  var track = useClickTracker5();
  var triggerImageBtn = React10.useRef(null);
  var _React10_useState = _sliced_to_array(React10.useState(0), 2),
    currentGalleryIndex = _React10_useState[0],
    setCurrentGalleryIndex = _React10_useState[1];
  var _useDialog2 = _sliced_to_array(useDialog2("review-".concat(id, "-photo-gallery-dialog"), "pwaPhotosReviewsDialog"), 3),
    isDialogOpen = _useDialog2[0],
    dialogActions = _useDialog2[1],
    DialogComponent = _useDialog2[2];
  var handleImageClick = React10.useCallback(function (index) {
    if (imageClickAnalytics) {
      var linkName = imageClickAnalytics.linkName;
      var referrerId = imageClickAnalytics.referrerId;
      if (reviewsPage && referrerId && linkName) {
        referrerId = referrerId.replace("reviewsPage", reviewsPage);
        track(referrerId, linkName);
      }
    }
    triggerImageBtn.current = document.activeElement;
    setCurrentGalleryIndex(index);
    dialogActions.openDialog();
  }, [dialogActions, imageClickAnalytics, reviewsPage, track]);
  var handleImageDialogClose = function () {
    var _triggerImageBtn_current;
    (_triggerImageBtn_current = triggerImageBtn.current) === null || _triggerImageBtn_current === void 0 ? void 0 : _triggerImageBtn_current.focus();
    dialogActions.closeDialog();
    if (exitAnalytics) {
      var linkName = exitAnalytics.linkName;
      var referrerId = exitAnalytics.referrerId;
      if (reviewsPage && referrerId && linkName) {
        referrerId = referrerId.replace("reviewsPage", reviewsPage);
        track(referrerId, linkName);
      }
    }
  };
  var navButtonAnalytics = reviewsPage && (navClickAnalytics === null || navClickAnalytics === void 0 ? void 0 : navClickAnalytics.referrerId) ? {
    id: navClickAnalytics.referrerId,
    description: navClickAnalytics.linkName,
    callback: function (referrerId, linkname) {
      return track(referrerId, linkname);
    }
  } : void 0;
  var galleryImages = React10.useMemo(function () {
    return photos === null || photos === void 0 ? void 0 : photos.map(function (photo) {
      return {
        src: photo.url,
        caption: photo.description
      };
    });
  }, [photos]);
  if (!(photos === null || photos === void 0 ? void 0 : photos.length)) {
    return null;
  }
  var mediaGalleryImageViewProps = {
    currentIndex: currentGalleryIndex,
    onIndexChange: setCurrentGalleryIndex
  };
  var RenderPhotos = /* @__PURE__ */React10.createElement(React10.Fragment, null, /* @__PURE__ */React10.createElement(EGDSSpacing8, {
    padding: {
      block: "two"
    }
  }, /* @__PURE__ */React10.createElement(EGDSLayoutGrid, {
    columns: 4,
    rows: 1
  }, photos.slice(0, 4).map(function (photo, index) {
    return /* @__PURE__ */React10.createElement(EGDSLayoutGridItem, {
      key: photo.url
    }, /* @__PURE__ */React10.createElement(EGDSFigure, {
      ratio: EGDSFigureAspectRatioType.R4_3,
      className: "all-image-fit-cover"
    }, /* @__PURE__ */React10.createElement(EGDSImage, {
      src: photo.url,
      alt: photo.description
    }), /* @__PURE__ */React10.createElement(EGDSImageLink, null, /* @__PURE__ */React10.createElement(EGDSButton, {
      onClick: function () {
        return handleImageClick(index);
      },
      domRef: triggerImageBtn
    }))));
  }))), /* @__PURE__ */React10.createElement(EGDSSheetTransition2, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React10.createElement(DialogComponent, null, /* @__PURE__ */React10.createElement(EGDSMediaGalleryImageDialog, {
    dialogShow: isDialogOpen,
    onDismiss: handleImageDialogClose,
    triggerRef: triggerImageBtn,
    strictFullscreen: true
  }, /* @__PURE__ */React10.createElement(EGDSMediaGalleryImageView, _object_spread_props(_object_spread({}, mediaGalleryImageViewProps), {
    images: galleryImages,
    stretchToFill: false,
    galleryName: reviewsPage,
    analytics: navButtonAnalytics
  }))))));
  if (reviewsPage === "ReviewsOverlay" /* REVIEWS_OVERLAY */ && intersectionAnalytics) {
    var referrerId = intersectionAnalytics.referrerId,
      linkName = intersectionAnalytics.linkName;
    return /* @__PURE__ */React10.createElement(IntersectionTracker, {
      trackOnce: true,
      referrerId: referrerId.replace("reviewsPage", "ReviewsOverlay" /* REVIEWS_OVERLAY */),
      linkName: linkName
    }, RenderPhotos);
  }
  return RenderPhotos;
};
Photos.displayName = "Photos";
Photos.fragment = __PhotosFragment;
// src/components/__private/__fragments/property-review-author.tsx
import React11 from "react";
import { gql as gql11 } from "@apollo/client";
import { EGDSHeading as EGDSHeading4 } from "@egds/react-core/text";
var __AuthorFragment = gql11(_templateObject12());
var PropertyReviewAuthor = function (param) {
  var data = param.data;
  var _data_reviewAuthorAttribution;
  var authorAttributionText = (_data_reviewAuthorAttribution = data.reviewAuthorAttribution) === null || _data_reviewAuthorAttribution === void 0 ? void 0 : _data_reviewAuthorAttribution.text;
  if (!authorAttributionText) {
    return null;
  }
  return /* @__PURE__ */React11.createElement(EGDSHeading4, {
    size: 7,
    tag: "h4"
  }, authorAttributionText);
};
PropertyReviewAuthor.displayName = "PropertyReviewAuthor";
PropertyReviewAuthor.fragment = __AuthorFragment;
// src/components/__private/__fragments/property-review-footer-section.tsx
import React12 from "react";
import { gql as gql12 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSMarkFlag } from "@egds/react-core/mark";
import { EGDSHeading as EGDSHeading5, EGDSText as EGDSText8 } from "@egds/react-core/text";
var fragment9 = gql12(_templateObject13());
var PropertyReviewFooterSection = function (param) {
  var data = param.data;
  return /* @__PURE__ */React12.createElement(React12.Fragment, null, data.messages.map(function (message, index) {
    var _message_text_graphic;
    return /* @__PURE__ */React12.createElement("div", {
      key: "review-footer-message-".concat(index)
    }, message.seoStructuredData && /* @__PURE__ */React12.createElement(EGDSHeading5, {
      size: 7,
      tag: "h5",
      itemScope: message.seoStructuredData.itemscope,
      itemProp: message.seoStructuredData.itemprop,
      itemType: message.seoStructuredData.itemtype,
      hidden: true
    }, /* @__PURE__ */React12.createElement("span", {
      itemProp: "name"
    }, message.seoStructuredData.content)), message.text && /* @__PURE__ */React12.createElement(EGDSLayoutFlex2, {
      space: "two"
    }, message.text.__typename === "EGDSGraphicText" && ((_message_text_graphic = message.text.graphic) === null || _message_text_graphic === void 0 ? void 0 : _message_text_graphic.__typename) === "Mark" && /* @__PURE__ */React12.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React12.createElement(EGDSMarkFlag, {
      name: message.text.graphic.id
    })), /* @__PURE__ */React12.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React12.createElement(EGDSText8, {
      size: 200,
      theme: "standard"
    }, message.text.text))));
  }));
};
PropertyReviewFooterSection.displayName = "PropertyReviewFooterSectionFragment";
PropertyReviewFooterSection.fragment = fragment9;
// src/components/__private/__fragments/property-review-region.tsx
import React13 from "react";
import { gql as gql13 } from "@apollo/client";
import { EGDSMarkFlag as EGDSMarkFlag2 } from "@egds/react-core/mark";
var fragment10 = gql13(_templateObject14());
var PropertyReviewRegion = function (param) {
  var data = param.data;
  if (!data || !data.reviewRegion) {
    return null;
  }
  return /* @__PURE__ */React13.createElement(EGDSMarkFlag2, {
    name: data.reviewRegion.id
  });
};
PropertyReviewRegion.displayName = "PropertyReviewRegion";
PropertyReviewRegion.fragment = fragment10;
// src/components/__private/__fragments/property-review-source.tsx
import React14 from "react";
import { gql as gql14 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { EGDSMark, EGDSMarkSize } from "@egds/react-core/mark";
import { EGDSSpacing as EGDSSpacing9 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText9 } from "@egds/react-core/text";
var __PropertyReviewSourceFragment = gql14(_templateObject15());
var PropertyReviewSource = function (param) {
  var data = param.data;
  var _ref = data.propertyReviewSource || {},
    text = _ref.text,
    graphic = _ref.graphic,
    accessibilityLabel = _ref.accessibilityLabel;
  if (!text || !text.value) {
    return null;
  }
  var _ref1 = graphic || {},
    id = _ref1.id,
    description = _ref1.description,
    url = _ref1.url;
  return /* @__PURE__ */React14.createElement(React14.Fragment, null, /* @__PURE__ */React14.createElement(EGDSLayoutFlex3, {
    space: "one",
    tabIndex: -1,
    alignItems: "end"
  }, /* @__PURE__ */React14.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React14.createElement(EGDSText9, {
    size: 200,
    theme: "standard",
    overflow: "truncate",
    "data-stid": "property-source"
  }, text.value)), /* @__PURE__ */React14.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React14.createElement(React14.Fragment, null, id && /* @__PURE__ */React14.createElement(EGDSSpacing9, {
    padding: {
      blockend: "one"
    }
  }, /* @__PURE__ */React14.createElement("div", null, /* @__PURE__ */React14.createElement(EGDSMark, {
    name: id,
    size: EGDSMarkSize.EXTRA_SMALL,
    description: description
  }))), !id && (url === null || url === void 0 ? void 0 : url.value) && /* @__PURE__ */React14.createElement(EGDSMark, {
    url: url.value,
    size: EGDSMarkSize.EXTRA_SMALL,
    description: description
  })))), accessibilityLabel && /* @__PURE__ */React14.createElement(EGDSText9, {
    className: "is-visually-hidden"
  }, accessibilityLabel));
};
PropertyReviewSource.displayName = "PropertyReviewSource";
PropertyReviewSource.fragment = __PropertyReviewSourceFragment;
// src/components/__private/__fragments/review-theme.tsx
import React15 from "react";
import { gql as gql15 } from "@apollo/client";
import { EGDSIcon as EGDSIcon5, EGDSIconSize as EGDSIconSize4 } from "@egds/react-core/icons";
import { EGDSSpacing as EGDSSpacing10 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText10 } from "@egds/react-core/text";
var __ReviewThemeFragment = gql15(_templateObject16());
var ReviewTheme = function (param) {
  var data = param.data,
    themeUniqueId = param.themeUniqueId;
  var label = data.label,
    icon = data.icon;
  if (!icon || !label) {
    return null;
  }
  return /* @__PURE__ */React15.createElement(EGDSSpacing10, {
    margin: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React15.createElement("div", null, /* @__PURE__ */React15.createElement(EGDSIcon5, {
    "aria-hidden": true,
    size: EGDSIconSize4.SMALL,
    name: icon.id,
    id: "".concat(icon.id, "-").concat(themeUniqueId)
  }), /* @__PURE__ */React15.createElement(EGDSSpacing10, {
    padding: {
      inlinestart: "two"
    }
  }, /* @__PURE__ */React15.createElement(EGDSText10, {
    size: 200,
    theme: "standard",
    inline: true
  }, label))));
};
ReviewTheme.displayName = "ReviewTheme";
ReviewTheme.fragment = __ReviewThemeFragment;
// src/components/__private/__fragments/review-translation-info-fragment.tsx
import React16 from "react";
import { gql as gql16 } from "@apollo/client";
import { EGDSLink as EGDSLink4 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing11 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText11 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
var __ReviewTranslationInfoFragment = gql16(_templateObject17());
var ReviewTranslationInfo = function (param) {
  var data = param.data,
    isLoading = param.isLoading,
    isTranslated = param.isTranslated,
    onTranslateClicked = param.onTranslateClicked;
  var translationInfo = data.translationInfo;
  var tracker = useClickTracker6();
  if (!translationInfo) {
    return null;
  }
  var trackedOnTranslateReviewClick = function () {
    tracker(TRANSLATE_TRACKER.rfrr, TRANSLATE_TRACKER.link);
    onTranslateClicked();
  };
  if (isLoading) {
    return /* @__PURE__ */React16.createElement(EGDSText11, {
      size: 200,
      theme: "standard"
    }, translationInfo.loadingTranslationText);
  }
  return /* @__PURE__ */React16.createElement(React16.Fragment, null, !isTranslated ? /* @__PURE__ */React16.createElement(EGDSSpacing11, {
    margin: {
      block: "two"
    }
  }, /* @__PURE__ */React16.createElement(EGDSLink4, {
    className: "uitk-type-300 ",
    size: "small",
    inline: true
  }, /* @__PURE__ */React16.createElement("button", {
    type: "button",
    onClick: trackedOnTranslateReviewClick
  }, translationInfo.translationCallToActionLabel))) : /* @__PURE__ */React16.createElement(React16.Fragment, null, /* @__PURE__ */React16.createElement(EGDSText11, {
    inline: true,
    size: 200,
    theme: "standard"
  }, translationInfo.translatedBy.description), /* @__PURE__ */React16.createElement(EGDSSpacing11, {
    margin: {
      block: "two",
      inlinestart: "two"
    }
  }, /* @__PURE__ */React16.createElement(EGDSLink4, {
    className: "uitk-type-300",
    size: "small",
    inline: true
  }, /* @__PURE__ */React16.createElement("button", {
    type: "button",
    onClick: onTranslateClicked
  }, translationInfo.seeOriginalText)))));
};
ReviewTranslationInfo.displayName = "ReviewTranslationInfo";
ReviewTranslationInfo.fragment = __ReviewTranslationInfoFragment;
// src/components/__private/__fragments/travelers.tsx
import React17 from "react";
import { gql as gql17 } from "@apollo/client";
import { EGDSText as EGDSText12 } from "@egds/react-core/text";
var __TravelersFragment = gql17(_templateObject18());
var Travelers = function (param) {
  var data = param.data;
  var travelers = data.travelers;
  if (!(travelers === null || travelers === void 0 ? void 0 : travelers.length)) {
    return null;
  }
  return /* @__PURE__ */React17.createElement(EGDSText12, {
    size: 300,
    theme: "standard"
  }, travelers.join(", "));
};
Travelers.displayName = "Travelers";
Travelers.fragment = __TravelersFragment;
// src/components/__private/__fragments/review-parent.tsx
var fragment11 = gql18(_templateObject19(), PropertyReviewAuthor.fragment, Photos.fragment, Travelers.fragment, ReviewTheme.fragment, feedback_indicator_default.fragment, ReviewTranslationInfo.fragment, PropertyReviewSource.fragment, PropertyReviewRegion.fragment, PropertyReviewFooterSection.fragment, EGDSSpannableText.fragment);
var translateReviewQuery = gql18(_templateObject20(), EGDSSpannableText.fragment);
var ReviewParent = function (param) {
  var data = param.data,
    children = param.children,
    propertyId = param.propertyId,
    reviewIndex = param.reviewIndex,
    reviewsPage = param.reviewsPage;
  var _translateData_propertyInfo_review, _translateData_propertyInfo, _translateData_propertyInfo_review1, _translateData_propertyInfo1;
  var id = data.id,
    superlative = data.superlative,
    disclaimer = data.disclaimer,
    themes = data.themes,
    submissionTime = data.submissionTime,
    title = data.title,
    text = data.text,
    highlightedText = data.highlightedText,
    seeMoreAnalytics = data.seeMoreAnalytics,
    reviewScoreWithDescription = data.reviewScoreWithDescription,
    impressionAnalytics = data.impressionAnalytics,
    reviewFooter = data.reviewFooter,
    reviewAnalytics = data.reviewAnalytics,
    reviewInteractionSections = data.reviewInteractionSections;
  var _React18_useState = _sliced_to_array(React18.useState(false), 2),
    isTranslated = _React18_useState[0],
    hasBeenTranslated = _React18_useState[1];
  var _React18_useState1 = _sliced_to_array(React18.useState(false), 2),
    isExpandoVisible = _React18_useState1[0],
    setIsExpandoVisible = _React18_useState1[1];
  var context = useBexApi4().context;
  var _useLazyQuery = _sliced_to_array(useLazyQuery(translateReviewQuery), 2),
    translateReviewQueryCallable = _useLazyQuery[0],
    result = _useLazyQuery[1];
  var translateData = result.data;
  var called = result.called,
    loading = result.loading;
  var clickTracker = useClickTracker7();
  var handleExpandoClick = React18.useCallback(function () {
    if (!isExpandoVisible && seeMoreAnalytics && seeMoreAnalytics.referrerId && reviewsPage) {
      clickTracker(seeMoreAnalytics.referrerId.concat(reviewsPage), seeMoreAnalytics.linkName);
    }
    setIsExpandoVisible(!isExpandoVisible);
  }, [isExpandoVisible, clickTracker, seeMoreAnalytics, reviewsPage]);
  var _ref = (reviewInteractionSections === null || reviewInteractionSections === void 0 ? void 0 : reviewInteractionSections.find(function (section) {
      return section.reviewInteractionType === "REVIEW_EXPAND_LABEL" /* REVIEW_EXPAND_LABEL */;
    })) || {},
    seeMoreLabel = _ref.primaryDisplayString,
    seeMoreA11yLabel = _ref.accessibilityLabel;
  var _ref1 = (reviewInteractionSections === null || reviewInteractionSections === void 0 ? void 0 : reviewInteractionSections.find(function (section) {
      return section.reviewInteractionType === "REVIEW_COLLAPSE_LABEL" /* REVIEW_COLLAPSE_LABEL */;
    })) || {},
    seeLessLabel = _ref1.primaryDisplayString,
    seeLessA11yLabel = _ref1.accessibilityLabel;
  var onTranslateClicked = function () {
    if (!called) {
      translateReviewQueryCallable({
        variables: {
          context: context,
          propertyId: propertyId,
          reviewId: id,
          locale: context.locale
        }
      });
    }
    hasBeenTranslated(!isTranslated);
  };
  var translatedText = translateData === null || translateData === void 0 ? void 0 : (_translateData_propertyInfo = translateData.propertyInfo) === null || _translateData_propertyInfo === void 0 ? void 0 : (_translateData_propertyInfo_review = _translateData_propertyInfo.review) === null || _translateData_propertyInfo_review === void 0 ? void 0 : _translateData_propertyInfo_review.translatedText;
  var translatedTitle = translateData === null || translateData === void 0 ? void 0 : (_translateData_propertyInfo1 = translateData.propertyInfo) === null || _translateData_propertyInfo1 === void 0 ? void 0 : (_translateData_propertyInfo_review1 = _translateData_propertyInfo1.review) === null || _translateData_propertyInfo_review1 === void 0 ? void 0 : _translateData_propertyInfo_review1.translatedTitle;
  var titleText = isTranslated && translatedTitle ? translatedTitle : title;
  var getReviewText = function (reviewText, highlightedReviewText) {
    var _highlightedReviewText_inlineContent;
    if (highlightedReviewText === null || highlightedReviewText === void 0 ? void 0 : (_highlightedReviewText_inlineContent = highlightedReviewText.inlineContent) === null || _highlightedReviewText_inlineContent === void 0 ? void 0 : _highlightedReviewText_inlineContent.length) {
      return /* @__PURE__ */React18.createElement(SearchHighlight, {
        inlineContentList: highlightedReviewText.inlineContent
      });
    }
    return reviewText;
  };
  var actionLocation = reviewsPage === "ReviewsOverlay" /* REVIEWS_OVERLAY */ ? "reviews_overlay" /* REVIEWS_OVERLAY */ : "pdp" /* REVIEWS */;
  var reviewImpressionAnalytics = {
    clientPayload: buildClientEvent("review.presented" /* PRESENTED */, EVENT_VERSION, actionLocation),
    serverPayload: reviewAnalytics
  };
  var article = /* @__PURE__ */React18.createElement("article", {
    itemProp: "review",
    itemScope: true,
    itemType: "http://schema.org/Review",
    id: id
  }, disclaimer && /* @__PURE__ */React18.createElement(EGDSSpacing12, {
    margin: {
      blockend: "two"
    }
  }, /* @__PURE__ */React18.createElement(EGDSText13, {
    size: 200,
    theme: "standard"
  }, /* @__PURE__ */React18.createElement("span", null, disclaimer))), superlative && /* @__PURE__ */React18.createElement(EGDSSpacing12, {
    padding: {
      blockend: "two"
    }
  }, /* @__PURE__ */React18.createElement("section", {
    itemProp: "reviewRating",
    itemScope: true,
    itemType: "http://schema.org/Rating",
    "data-stid": "property-reviews-parent__section-superlative"
  }, (reviewScoreWithDescription === null || reviewScoreWithDescription === void 0 ? void 0 : reviewScoreWithDescription.value) && /* @__PURE__ */React18.createElement(EGDSHeading6, {
    tag: "h3",
    size: 5,
    "aria-label": reviewScoreWithDescription.label || ""
  }, /* @__PURE__ */React18.createElement("span", {
    itemProp: "ratingValue"
  }, reviewScoreWithDescription.value)))), /* @__PURE__ */React18.createElement("section", null, /* @__PURE__ */React18.createElement(PropertyReviewAuthor, {
    data: data
  }), /* @__PURE__ */React18.createElement(Travelers, {
    data: data
  }), /* @__PURE__ */React18.createElement(EGDSText13, {
    size: 300,
    theme: "standard"
  }, /* @__PURE__ */React18.createElement("span", {
    itemProp: "datePublished"
  }, submissionTime.longDateFormat))), themes && themes.length > 0 && /* @__PURE__ */React18.createElement(EGDSSpacing12, {
    margin: {
      block: "two"
    }
  }, /* @__PURE__ */React18.createElement("section", {
    "data-stid": "property-reviews-parent__section-sentiments"
  }, themes.map(function (theme, index) {
    return /* @__PURE__ */React18.createElement(ReviewTheme, {
      themeUniqueId: "".concat(id, "-").concat(index),
      data: theme,
      key: "review-theme-".concat(index)
    });
  }))), /* @__PURE__ */React18.createElement(ReviewTranslationInfo, {
    data: data,
    isLoading: loading,
    isTranslated: isTranslated,
    onTranslateClicked: onTranslateClicked
  }), (title || text || highlightedText) && /* @__PURE__ */React18.createElement(EGDSSpacing12, {
    margin: {
      block: "two"
    }
  }, /* @__PURE__ */React18.createElement("section", null, titleText && /* @__PURE__ */React18.createElement(EGDSHeading6, {
    tag: "h5",
    size: 6,
    "data-stid": "review_section_title"
  }, /* @__PURE__ */React18.createElement("span", {
    itemProp: "name"
  }, titleText)), /* @__PURE__ */React18.createElement(EGDSSpacing12, {
    padding: {
      blockstart: "two"
    }
  }, seeMoreLabel && seeLessLabel ? /* @__PURE__ */React18.createElement(EGDSExpandoPeek, {
    isVisible: isExpandoVisible,
    lines: 5,
    expandLabel: seeMoreLabel,
    collapseLabel: seeLessLabel,
    expandA11yLabel: seeMoreA11yLabel !== null && seeMoreA11yLabel !== void 0 ? seeMoreA11yLabel : "",
    collapseA11yLabel: seeLessA11yLabel !== null && seeLessA11yLabel !== void 0 ? seeLessA11yLabel : "",
    handleClick: handleExpandoClick
  }, /* @__PURE__ */React18.createElement(EGDSText13, {
    size: 300,
    theme: "standard"
  }, /* @__PURE__ */React18.createElement("span", {
    itemProp: "description"
  }, isTranslated && translatedText ? translatedText : getReviewText(text, highlightedText)))) : /* @__PURE__ */React18.createElement(EGDSText13, {
    size: 300,
    theme: "standard"
  }, /* @__PURE__ */React18.createElement("span", {
    itemProp: "description"
  }, isTranslated && translatedText ? translatedText : getReviewText(text, highlightedText)))))), /* @__PURE__ */React18.createElement(Photos, {
    data: data,
    reviewsPage: reviewsPage
  }), /* @__PURE__ */React18.createElement(EGDSSpacing12, {
    margin: {
      block: "two"
    }
  }, /* @__PURE__ */React18.createElement("section", null, /* @__PURE__ */React18.createElement(EGDSLayoutFlex4, {
    justifyContent: "space-between",
    alignItems: "end"
  }, /* @__PURE__ */React18.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React18.createElement(EGDSLayoutFlex4, {
    direction: "column"
  }, reviewFooter && /* @__PURE__ */React18.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React18.createElement(EGDSLayoutFlex4, {
    space: "two",
    direction: "row"
  }, /* @__PURE__ */React18.createElement(PropertyReviewFooterSection, {
    data: reviewFooter
  }))), /* @__PURE__ */React18.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React18.createElement(EGDSSpacing12, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React18.createElement(EGDSLayoutFlex4, {
    justifyContent: "start"
  }, /* @__PURE__ */React18.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React18.createElement(feedback_indicator_default, {
    reviewId: id,
    reviewIndex: reviewIndex,
    data: data,
    reviewsPage: reviewsPage
  })), /* @__PURE__ */React18.createElement(EGDSLayoutFlexItem4, null, children)))))), /* @__PURE__ */React18.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React18.createElement(PropertyReviewSource, {
    data: data
  }))))));
  var _ref2 = impressionAnalytics || {},
    _ref_referrerId = _ref2.referrerId,
    referrerId = _ref_referrerId === void 0 ? "" : _ref_referrerId,
    tmp = _ref2.event,
    link = tmp === void 0 ? "" : tmp;
  if (reviewsPage === "ReviewsOverlay" /* REVIEWS_OVERLAY */ && referrerId && link) {
    return /* @__PURE__ */React18.createElement(IntersectionTracker2, {
      trackOnce: true,
      referrerId: referrerId,
      linkName: link
    }, /* @__PURE__ */React18.createElement(EgClickstreamImpressionTracker, {
      eventData: reviewImpressionAnalytics
    }, " ", article, " "));
  }
  return /* @__PURE__ */React18.createElement(EgClickstreamImpressionTracker, {
    eventData: reviewImpressionAnalytics
  }, " ", article, " ");
};
ReviewParent.displayName = "ReviewParent";
ReviewParent.fragment = fragment11;
var review_parent_default = ReviewParent;
// src/components/__private/__fragments/property-reviews-list-fragment.ts
var PropertyReviewsListFragment = gql19(_templateObject21(), review_parent_default.fragment, review_child_default.fragment, NoResultsMessage.fragment);
// src/components/__private/__fragments/property-reviews-list.tsx
var PropertyReviewsList = function (param) {
  var data = param.data,
    fetchMore = param.fetchMore,
    hideManagementResponse = param.hideManagementResponse,
    propertyId = param.propertyId,
    size = param.size,
    _param_showLoadMoreCTA = param.showLoadMoreCTA,
    showLoadMoreCTA = _param_showLoadMoreCTA === void 0 ? true : _param_showLoadMoreCTA,
    reviewsPage = param.reviewsPage;
  var cache = useApolloClient().cache;
  var reviews = data.reviews,
    summary = data.summary;
  var paginateAction = summary === null || summary === void 0 ? void 0 : summary.paginateAction;
  var _ref = (paginateAction === null || paginateAction === void 0 ? void 0 : paginateAction.analytics) || {},
    referrerId = _ref.referrerId,
    linkName = _ref.linkName;
  var tracker = useClickTracker8();
  var pageParams = useQueryParams();
  var deleteParam = useDeleteParam();
  var scrollElementRef = useRef();
  var isReviewsOverlay = reviewsPage === "ReviewsOverlay" /* REVIEWS_OVERLAY */;
  React19.useEffect(function () {
    if (isReviewsOverlay && pageParams.get("reviewId")) {
      var _scrollElementRef_current;
      var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      (_scrollElementRef_current = scrollElementRef.current) === null || _scrollElementRef_current === void 0 ? void 0 : _scrollElementRef_current.scrollIntoView({
        behavior: prefersReducedMotion ? "auto" : "smooth",
        block: "start"
      });
      deleteParam("reviewId");
    }
  }, [deleteParam, isReviewsOverlay, pageParams, reviewsPage]);
  var impressionAnalytics = {
    clientPayload: buildClientEvent("reviews.viewed" /* VIEWED */, EVENT_VERSION),
    serverPayload: data.impressionAnalytics
  };
  var loadMoreReviews = function () {
    if (referrerId && linkName) {
      tracker(referrerId, linkName);
    }
    fetchMore({
      variables: {
        searchCriteria: {
          secondary: {
            counts: [{
              id: "startIndex",
              value: reviews.length
            }, {
              id: "size",
              value: size
            }]
          }
        }
      },
      updateQuery: function (prev, param) {
        var fetchMoreResult = param.fetchMoreResult;
        if (!fetchMoreResult) {
          return prev;
        }
        return _object_spread_props(_object_spread({}, prev), {
          propertyInfo: _object_spread_props(_object_spread({}, prev.propertyInfo), {
            reviewInfo: _object_spread_props(_object_spread({}, prev.propertyInfo.reviewInfo), {
              summary: _object_spread({}, prev.propertyInfo.reviewInfo.summary, fetchMoreResult.propertyInfo.reviewInfo.summary),
              reviews: _to_consumable_array(prev.propertyInfo.reviewInfo.reviews).concat(_to_consumable_array(fetchMoreResult.propertyInfo.reviewInfo.reviews))
            })
          })
        });
      }
    });
  };
  var getHideReview = function (reviewId) {
    return function () {
      var cacheId = cache.identify({
        id: reviewId,
        __typename: "PropertyReview"
      });
      cache.evict({
        id: cacheId
      });
      cache.gc();
    };
  };
  var reviewContent = /* @__PURE__ */React19.createElement(EGDSCard2, null, reviews && reviews.length > 0 && reviews.map(function (review, index) {
    var managementResponses = review.managementResponses,
      id = review.id,
      brandType = review.brandType;
    return /* @__PURE__ */React19.createElement(EGDSCardContentSection, {
      border: "bottom",
      key: "review-".concat(id),
      "data-stid": "property-reviews-list-item"
    }, /* @__PURE__ */React19.createElement("div", {
      ref: review.id === pageParams.get("reviewId") ? scrollElementRef : null
    }, /* @__PURE__ */React19.createElement(review_parent_default, {
      data: review,
      propertyId: propertyId,
      reviewIndex: index + 1,
      reviewsPage: reviewsPage
    }, review.contentDirectFeedbackPromptId && /* @__PURE__ */React19.createElement(ContentDirectFeedbackCallToAction, {
      dialogId: id,
      feedbackContext: [{
        key: "brand",
        value: brandType || ""
      }, {
        key: "property_id",
        value: propertyId
      }, {
        key: "review_id",
        value: id
      }],
      hideReview: getHideReview(id),
      inputs: {
        id: review.contentDirectFeedbackPromptId
      }
    }))), !hideManagementResponse && managementResponses.length > 0 && review.managementResponses[0] && /* @__PURE__ */React19.createElement(review_child_default, {
      data: review.managementResponses[0]
    }));
  }), /* @__PURE__ */React19.createElement(NoResultsMessage, {
    data: data
  }));
  var reviewContentWithImpression = /* @__PURE__ */React19.createElement(EgClickstreamImpressionTracker2, {
    eventData: impressionAnalytics
  }, reviewContent);
  return /* @__PURE__ */React19.createElement("section", null, isReviewsOverlay ? reviewContentWithImpression : reviewContent, paginateAction && showLoadMoreCTA && /* @__PURE__ */React19.createElement(EGDSSpacing13, {
    margin: {
      block: "three"
    }
  }, /* @__PURE__ */React19.createElement("div", {
    className: "uitk-type-center"
  }, /* @__PURE__ */React19.createElement(EGDSSecondaryButton, {
    onClick: loadMoreReviews
  }, paginateAction === null || paginateAction === void 0 ? void 0 : paginateAction.text))));
};
PropertyReviewsList.displayName = "PropertyReviewsList";
PropertyReviewsList.fragment = PropertyReviewsListFragment;
var property_reviews_list_default = PropertyReviewsList;
// src/components/property-reviews-list.tsx
var __ReviewQuery = gql20(_templateObject22(), PropertyReviewsListFragment);
var DEFAULT_STARTING_INDEX2 = 0;
var DEFAULT_PAGINATION_SIZE2 = 10;
var PropertyReviewsList2 = React20.memo(function (props) {
  var _inputs_pagination, _inputs_pagination1;
  var searchCriteria = props.inputs.searchCriteria,
    inputs = _object_without_properties(props.inputs, ["searchCriteria"]);
  var context = useBexApi5().context;
  var propertyId = String(inputs.propertyId);
  var size = (inputs === null || inputs === void 0 ? void 0 : (_inputs_pagination = inputs.pagination) === null || _inputs_pagination === void 0 ? void 0 : _inputs_pagination.size) || DEFAULT_PAGINATION_SIZE2;
  var startingIndex = (inputs === null || inputs === void 0 ? void 0 : (_inputs_pagination1 = inputs.pagination) === null || _inputs_pagination1 === void 0 ? void 0 : _inputs_pagination1.startingIndex) || DEFAULT_STARTING_INDEX2;
  var variables = {
    context: context,
    propertyId: propertyId,
    searchCriteria: {
      primary: searchCriteria.primary,
      secondary: {
        booleans: [{
          id: "includeRecentReviews",
          value: true
        }, {
          id: "includeRatingsOnlyReviews",
          value: true
        }],
        counts: [{
          id: "startIndex",
          value: startingIndex
        }, {
          id: "size",
          value: size
        }],
        selections: [{
          id: "sortBy",
          value: DEFAULT_REVIEWS_SORT
        }]
      }
    }
  };
  var _useQuery2 = useQuery2(__ReviewQuery, {
      variables: variables,
      errorPolicy: "all",
      fetchPolicy: "cache-first"
    }),
    data = _useQuery2.data,
    error = _useQuery2.error,
    loading = _useQuery2.loading,
    fetchMore = _useQuery2.fetchMore;
  if (loading || error || !data) {
    return null;
  }
  var paginationFetch = buildFetchMoreReviews(fetchMore, variables);
  return /* @__PURE__ */React20.createElement(property_reviews_list_default, {
    propertyId: propertyId,
    size: size,
    data: data.propertyInfo.reviewInfo,
    fetchMore: paginationFetch
  });
});
PropertyReviewsList2.displayName = "sharedui-PropertyReviewsList";
// src/components/property-reviews-summary.tsx
import React22 from "react";
import { gql as gql22, useQuery as useQuery3 } from "@apollo/client";
import { useBexApi as useBexApi6 } from "@shared-ui/bex-api-context";
// src/components/__private/__fragments/property-reviews-summary-fragment.tsx
import React21 from "react";
import { gql as gql21 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex5 } from "@egds/react-core/layout-flex";
import { EGDSProgressBar } from "@egds/react-core/progress-bar";
import { EGDSSpacing as EGDSSpacing14 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText14 } from "@egds/react-core/text";
import { getStructuredDataProps, LodgingEnrichedMessage, ReviewDisclaimer } from "@shared-ui/lodging-fragments";
var fragment12 = gql21(_templateObject23(), ReviewDisclaimer.fragment, LodgingEnrichedMessage.fragment);
var PropertyReviewsSummaryFragment = function (param) {
  var data = param.data,
    _param_withAggregateRating = param.withAggregateRating,
    withAggregateRating = _param_withAggregateRating === void 0 ? false : _param_withAggregateRating,
    reviewPage = param.reviewPage,
    _param_children = param.children,
    children = _param_children === void 0 ? null : _param_children;
  var overallScoreWithDescriptionA11y = data.overallScoreWithDescriptionA11y,
    propertyReviewCountDetails = data.propertyReviewCountDetails,
    reviewSummaryDetails = data.reviewSummaryDetails,
    totalCount = data.totalCount;
  return /* @__PURE__ */React21.createElement(EGDSSpacing14, {
    margin: {
      blockend: "two"
    }
  }, /* @__PURE__ */React21.createElement("div", _object_spread({
    "data-stid": "property-reviews-summary"
  }, getStructuredDataProps("aggregateRating", withAggregateRating)), overallScoreWithDescriptionA11y && /* @__PURE__ */React21.createElement(LodgingEnrichedMessage, {
    data: overallScoreWithDescriptionA11y,
    textSize: 500
  }), /* @__PURE__ */React21.createElement("span", _object_spread({
    className: "is-visually-hidden",
    "aria-hidden": "true"
  }, getStructuredDataProps("reviewCount", withAggregateRating)), totalCount === null || totalCount === void 0 ? void 0 : totalCount.raw), /* @__PURE__ */React21.createElement(EGDSText14, {
    size: 400,
    spacing: "one"
  }, propertyReviewCountDetails === null || propertyReviewCountDetails === void 0 ? void 0 : propertyReviewCountDetails.fullDescription), /* @__PURE__ */React21.createElement(ReviewDisclaimer, {
    data: data,
    reviewPage: reviewPage
  }), children, !!(reviewSummaryDetails === null || reviewSummaryDetails === void 0 ? void 0 : reviewSummaryDetails.length) && /* @__PURE__ */React21.createElement(EGDSLayoutFlex5, {
    direction: "column",
    space: "two"
  }, reviewSummaryDetails.map(function (reviewSummaryDetailItem, index) {
    return /* @__PURE__ */React21.createElement(EGDSSpacing14, {
      padding: {
        blockstart: "two"
      },
      key: "category-".concat(reviewSummaryDetailItem === null || reviewSummaryDetailItem === void 0 ? void 0 : reviewSummaryDetailItem.label)
    }, /* @__PURE__ */React21.createElement("div", null, /* @__PURE__ */React21.createElement(EGDSProgressBar, {
      percent: reviewSummaryDetailItem === null || reviewSummaryDetailItem === void 0 ? void 0 : reviewSummaryDetailItem.ratingPercentage,
      progressDescription: reviewSummaryDetailItem === null || reviewSummaryDetailItem === void 0 ? void 0 : reviewSummaryDetailItem.formattedRatingOutOfMax,
      title: reviewSummaryDetailItem === null || reviewSummaryDetailItem === void 0 ? void 0 : reviewSummaryDetailItem.label
    })));
  }))));
};
PropertyReviewsSummaryFragment.displayName = "PropertyReviewsSummaryFragment";
PropertyReviewsSummaryFragment.fragment = fragment12;
var property_reviews_summary_fragment_default = PropertyReviewsSummaryFragment;
// src/components/property-reviews-summary.tsx
var __PropertyReviewSummariesQuery = gql22(_templateObject24(), property_reviews_summary_fragment_default.fragment);
var PropertyReviewsSummary = function (param) {
  var propertyId = param.inputs.propertyId,
    _param_withAggregateRating = param.withAggregateRating,
    withAggregateRating = _param_withAggregateRating === void 0 ? false : _param_withAggregateRating;
  var context = useBexApi6().context;
  var variables = {
    context: context,
    propertyIds: propertyId ? [propertyId] : []
  };
  var _useQuery3 = useQuery3(__PropertyReviewSummariesQuery, {
      variables: variables,
      errorPolicy: "all",
      fetchPolicy: "cache-first"
    }),
    data = _useQuery3.data,
    error = _useQuery3.error,
    loading = _useQuery3.loading;
  if (loading || error || !(data === null || data === void 0 ? void 0 : data.propertyReviewSummaries) || data.propertyReviewSummaries.length === 0 || !data.propertyReviewSummaries[0]) {
    return null;
  }
  return /* @__PURE__ */React22.createElement(property_reviews_summary_fragment_default, {
    withAggregateRating: withAggregateRating,
    data: data.propertyReviewSummaries[0]
  });
};
// src/components/property-reviews-snippets.tsx
import React23 from "react";
import { gql as gql23, useQuery as useQuery4 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex6, EGDSLayoutFlexItem as EGDSLayoutFlexItem5 } from "@egds/react-core/layout-flex";
import { EGDSText as EGDSText15 } from "@egds/react-core/text";
var __PropertyReviewsSnippetsQuery = gql23(_templateObject25());
var PropertyReviewsSnippets = function (param) {
  var _param_inputs = param.inputs,
    context = _param_inputs.context,
    propertyId = _param_inputs.propertyId;
  var variables = {
    context: context,
    propertyIds: propertyId
  };
  var _useQuery4 = useQuery4(__PropertyReviewsSnippetsQuery, {
      variables: variables,
      errorPolicy: "all",
      fetchPolicy: "cache-first"
    }),
    data = _useQuery4.data,
    error = _useQuery4.error,
    loading = _useQuery4.loading;
  if (loading || error || !data || !data.propertyReviewAggregates || !data.propertyReviewAggregates.propertySentiment || !data.propertyReviewAggregates.propertySentiment.length) {
    return null;
  }
  var propertySentiments = data.propertyReviewAggregates.propertySentiment;
  return /* @__PURE__ */React23.createElement(EGDSLayoutFlex6, {
    space: "six"
  }, propertySentiments.map(function (propertySentiment, index) {
    return /* @__PURE__ */React23.createElement(EGDSLayoutFlexItem5, {
      key: "review-".concat(index)
    }, /* @__PURE__ */React23.createElement("div", null, /* @__PURE__ */React23.createElement(EGDSText15, {
      weight: "bold",
      size: 300
    }, propertySentiment.text), /* @__PURE__ */React23.createElement(EGDSText15, {
      size: 300
    }, propertySentiment.subtext)));
  }));
};
// src/components/property-reviews-summary-line.tsx
import React24 from "react";
import { gql as gql24, useQuery as useQuery5 } from "@apollo/client";
import { EGDSIcon as EGDSIcon6, EGDSIconSize as EGDSIconSize5 } from "@egds/react-core/icons";
import { EGDSLink as EGDSLink5 } from "@egds/react-core/link";
import { EGDSMenu, EGDSMenuContainer, EGDSMenuTrigger, PositionType } from "@egds/react-core/menu";
import { EGDSMoreInfoTrigger } from "@egds/react-core/more-info-trigger";
import { EGDSSpacing as EGDSSpacing15 } from "@egds/react-core/spacing";
import { useBexApi as useBexApi7 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker9 } from "@shared-ui/clickstream-analytics-context";
var __PropertyReviewSummariesLineQuery = gql24(_templateObject26());
var PropertyReviewsSummaryLine = function (param) {
  var propertyId = param.inputs.propertyId;
  var context = useBexApi7().context;
  var variables = {
    propertyIds: propertyId ? [propertyId] : [],
    context: context
  };
  var tracker = useClickTracker9();
  var _React24_useState = _sliced_to_array(React24.useState(false), 2),
    showMenu = _React24_useState[0],
    setShowMenu = _React24_useState[1];
  var _useQuery5 = useQuery5(__PropertyReviewSummariesLineQuery, {
      variables: variables,
      errorPolicy: "all",
      fetchPolicy: "cache-first"
    }),
    data = _useQuery5.data,
    error = _useQuery5.error,
    loading = _useQuery5.loading;
  if (loading || error) {
    return null;
  }
  if (!data || !data.propertyReviewSummaries || !data.propertyReviewSummaries.length || !data.propertyReviewSummaries[0]) {
    return null;
  }
  var _data_propertyReviewSummaries_ = data.propertyReviewSummaries[0],
    overallScoreWithDescription = _data_propertyReviewSummaries_.overallScoreWithDescription,
    propertyReviewCountDetails = _data_propertyReviewSummaries_.propertyReviewCountDetails,
    reviewDisclaimer = _data_propertyReviewSummaries_.reviewDisclaimer,
    reviewDisclaimerAccessibilityLabel = _data_propertyReviewSummaries_.reviewDisclaimerAccessibilityLabel,
    totalCount = _data_propertyReviewSummaries_.totalCount;
  return /* @__PURE__ */React24.createElement("div", {
    className: "uitk-layout-flex",
    itemProp: "aggregateRating",
    itemScope: true,
    itemType: "http://schema.org/AggregateRating",
    "data-stid": "property-reviews-summary-line"
  }, overallScoreWithDescription && /* @__PURE__ */React24.createElement(EGDSSpacing15, {
    margin: {
      inlineend: "one"
    }
  }, /* @__PURE__ */React24.createElement("span", {
    itemProp: "ratingValue",
    className: "uitk-type-bold"
  }, overallScoreWithDescription)), totalCount && /* @__PURE__ */React24.createElement("span", {
    "aria-hidden": true,
    className: "is-visually-hidden",
    itemProp: "reviewCount"
  }, totalCount.raw), propertyReviewCountDetails && /* @__PURE__ */React24.createElement("span", null, propertyReviewCountDetails.fullDescription), /* @__PURE__ */React24.createElement(EGDSMenu, {
    isOpen: showMenu,
    onTriggerClick: function () {
      tracker(DISCLAIMER_DIALOG_TRACKER.rfrr, DISCLAIMER_DIALOG_TRACKER.link);
      setShowMenu(!showMenu);
    }
  }, /* @__PURE__ */React24.createElement(EGDSMenuTrigger, null, /* @__PURE__ */React24.createElement(EGDSLink5, {
    inline: true
  }, /* @__PURE__ */React24.createElement(EGDSMoreInfoTrigger, null, /* @__PURE__ */React24.createElement("button", {
    type: "button"
  }, /* @__PURE__ */React24.createElement(EGDSIcon6, {
    name: "info_outline",
    id: "property-reviews-summary-disclaimer",
    size: EGDSIconSize5.EXTRA_SMALL,
    title: reviewDisclaimerAccessibilityLabel || void 0
  }))))), /* @__PURE__ */React24.createElement(EGDSMenuContainer, {
    position: PositionType.RIGHT,
    width: 300
  }, /* @__PURE__ */React24.createElement(EGDSSpacing15, {
    padding: {
      inline: "four"
    }
  }, /* @__PURE__ */React24.createElement("p", {
    "data-stid": "review-disclaimer"
  }, reviewDisclaimer)))));
};
// src/components/property-reviews-breakdown.tsx
import React31 from "react";
import { gql as gql30, useQuery as useQuery7 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing18 } from "@egds/react-core/spacing";
import { useBexApi as useBexApi9 } from "@shared-ui/bex-api-context";
import { PropertyFilteredReviewsDialogContext, PropertyReviewsBreakdown as PropertyReviewsBreakdownFragment } from "@shared-ui/lodging-fragments";
// src/components/property-filtered-reviews.tsx
import React30, { useMemo as useMemo5 } from "react";
import { gql as gql29, useQuery as useQuery6 } from "@apollo/client";
import { EGDSCard as EGDSCard3, EGDSCardContentSection as EGDSCardContentSection2 } from "@egds/react-core/cards";
import { EGDSFigure as EGDSFigure2, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType2 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex9, EGDSLayoutFlexItem as EGDSLayoutFlexItem7 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid2, EGDSLayoutGridItem as EGDSLayoutGridItem2 } from "@egds/react-core/layout-grid";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
import { EGDSLoader } from "@egds/react-core/loader";
import { EGDSBlockSkeleton, EGDSLineSkeleton } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing17 } from "@egds/react-core/spacing";
import { useBexApi as useBexApi8 } from "@shared-ui/bex-api-context";
import { useExperiment } from "@shared-ui/experiment-context";
import { IdentifierType as IdentifierType2, ProductReviewDetails } from "@shared-ui/retail-product-review-details";
// src/components/__private/__fragments/popular-mentions.tsx
import React25 from "react";
import { gql as gql25 } from "@apollo/client";
import { EGDSExpandoPeek as EGDSExpandoPeek2 } from "@egds/react-core/expando";
import { EGDSLayoutFlex as EGDSLayoutFlex7 } from "@egds/react-core/layout-flex";
import { EGDSPill, EGDSPillContainer } from "@egds/react-core/pill";
import { EGDSSpacing as EGDSSpacing16 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading7 } from "@egds/react-core/text";
import { Level as Level2, liveAnnounce as liveAnnounce2 } from "@egds/react-core/utils";
import { useClickTracker as useClickTracker10 } from "@shared-ui/clickstream-analytics-context";
var fragment13 = gql25(_templateObject27());
var PopularMentions = function (param) {
  var data = param.data,
    popularMentionInput = param.popularMentionInput,
    _param_otherFiltersApplied = param.otherFiltersApplied,
    otherFiltersApplied = _param_otherFiltersApplied === void 0 ? false : _param_otherFiltersApplied,
    setPopularMention = param.setPopularMention,
    resetFilters = param.resetFilters;
  var _popularMentionsData_options;
  var popularMentionsData = data.sortAndFilter.find(function (o) {
    return o.title === POPULAR_MENTION_FILTER_NAME;
  });
  var refPopularMentionsElement = React25.createRef();
  var liveAnnounceId = "popular-mention-live-announce-id";
  var _React25_useState = _sliced_to_array(React25.useState(false), 2),
    isVisible = _React25_useState[0],
    setIsVisible = _React25_useState[1];
  var track = useClickTracker10();
  var previousPopularMentionHandler = React25.useCallback(function () {
    var _ref = (popularMentionsData === null || popularMentionsData === void 0 ? void 0 : popularMentionsData.options.find(function (i) {
        return i.isSelected;
      })) || {},
      clickAnalytics2 = _ref.clickAnalytics;
    if (clickAnalytics2) {
      track("".concat(clickAnalytics2.referrerId, ".False"), "Deselected ".concat(clickAnalytics2.linkName));
    }
  }, [popularMentionsData, track]);
  if (!popularMentionsData || !(popularMentionsData === null || popularMentionsData === void 0 ? void 0 : (_popularMentionsData_options = popularMentionsData.options) === null || _popularMentionsData_options === void 0 ? void 0 : _popularMentionsData_options.length) || !popularMentionsData.label) {
    return null;
  }
  var clickAnalytics = popularMentionsData.clickAnalytics,
    placeholder = popularMentionsData.placeholder,
    label = popularMentionsData.label,
    showListOptions = popularMentionsData.showListOptions,
    options = popularMentionsData.options;
  var expandoReferrerId = "".concat(clickAnalytics === null || clickAnalytics === void 0 ? void 0 : clickAnalytics.referrerId, ".").concat(!isVisible ? "SeeMore" : "SeeLess");
  var expandoLinkName = "".concat(!isVisible ? "See more " : "See less ").concat(clickAnalytics === null || clickAnalytics === void 0 ? void 0 : clickAnalytics.linkName);
  var expandoPeekAnalysis = {
    id: expandoReferrerId,
    description: expandoLinkName,
    callback: function (refererId, lnkName) {
      track(refererId.replace(/\.closed|\.opened/g, ""), lnkName);
    }
  };
  var handlePillChange = function (popularMention) {
    var optionValue = popularMention.optionValue,
      pillAnalytics = popularMention.clickAnalytics,
      ariaLabel = popularMention.ariaLabel,
      isSelected = popularMention.isSelected;
    if (!isSelected) {
      liveAnnounce2(ariaLabel, Level2.POLITE, "is-visually-hidden", refPopularMentionsElement, liveAnnounceId);
      resetFilters === null || resetFilters === void 0 ? void 0 : resetFilters("popularMention");
      setPopularMention(optionValue);
      track("".concat(pillAnalytics.referrerId, ".True"), "Selected ".concat(pillAnalytics.linkName));
      previousPopularMentionHandler();
    }
  };
  return /* @__PURE__ */React25.createElement("div", {
    ref: refPopularMentionsElement
  }, /* @__PURE__ */React25.createElement(EGDSSpacing16, {
    margin: {
      blockend: "four"
    },
    border: ["blockend"],
    padding: {
      blockend: options.length > DEFAULT_POPULAR_MENTIONS_VIEW_IN ? "one" : "four"
    }
  }, /* @__PURE__ */React25.createElement(EGDSLayoutFlex7, {
    space: "two",
    direction: "column"
  }, /* @__PURE__ */React25.createElement(EGDSHeading7, {
    tag: "h3",
    size: 6,
    "aria-label": placeholder || ""
  }, label), /* @__PURE__ */React25.createElement(EGDSSpacing16, {
    margin: {
      blockend: "unset"
    }
  }, /* @__PURE__ */React25.createElement(EGDSExpandoPeek2, {
    items: DEFAULT_POPULAR_MENTIONS_VIEW_IN,
    whitespace: false,
    hideScrim: true,
    isVisible: isVisible,
    expandLabel: showListOptions === null || showListOptions === void 0 ? void 0 : showListOptions.seeMoreLabel,
    collapseLabel: showListOptions === null || showListOptions === void 0 ? void 0 : showListOptions.seeLessLabel,
    handleClick: function () {
      return setIsVisible(function (prevIsVisible) {
        return !prevIsVisible;
      });
    },
    analytics: expandoPeekAnalysis
  }, /* @__PURE__ */React25.createElement(EGDSPillContainer, {
    wrap: true
  }, options.map(function (item, index) {
    return /* @__PURE__ */React25.createElement(EGDSPill, {
      id: "wrapped-popular-".concat(index),
      key: "popular-mention-".concat(index),
      checked: !otherFiltersApplied && popularMentionInput === (item === null || item === void 0 ? void 0 : item.optionValue),
      onChange: function () {
        return handlePillChange(item);
      }
    }, item.label);
  })))))));
};
PopularMentions.fragment = fragment13;
PopularMentions.displayName = "PopularMentions";
var popular_mentions_default = PopularMentions;
// src/components/__private/__fragments/search-box.tsx
import React26, { useMemo as useMemo2 } from "react";
import { gql as gql26 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize2, EGDSPrimaryButton as EGDSPrimaryButton2 } from "@egds/react-core/button";
import { EGDSForm } from "@egds/react-core/form";
import { EGDSIcon as EGDSIcon7 } from "@egds/react-core/icons";
import { EGDSTextInput } from "@egds/react-core/input";
import { EGDSLayoutFlex as EGDSLayoutFlex8, EGDSLayoutFlexItem as EGDSLayoutFlexItem6 } from "@egds/react-core/layout-flex";
import { useEgClickstream } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
var fragment14 = gql26(_templateObject28());
var SearchBox = function (param) {
  var data = param.data,
    setSearchInputVal = param.setSearchInputVal,
    searchInputVal = param.searchInputVal,
    resetFilters = param.resetFilters;
  var _React26_useState = _sliced_to_array(React26.useState(searchInputVal), 2),
    inputVal = _React26_useState[0],
    setInputVal = _React26_useState[1];
  var searchData = data.sortAndFilter.find(function (o) {
    return o.name === "reviewsSearch";
  });
  var trackEvent = useEgClickstream();
  useMemo2(function () {
    setInputVal(searchInputVal);
  }, [searchInputVal]);
  if (!searchData || !searchData.label || !searchData.name || !searchData.graphic) {
    return null;
  }
  var label = searchData.label,
    name = searchData.name,
    submittedAnalytics = searchData.submittedAnalytics,
    initiatedAnalytics = searchData.initiatedAnalytics,
    graphic = searchData.graphic;
  var iconId = graphic.id,
    buttonTitle = graphic.description,
    iconToken = graphic.token;
  if (!iconId || !buttonTitle || !iconToken) {
    return null;
  }
  var handleChange = function (event) {
    var value = event.target.value;
    setInputVal(value);
    if (value === "") {
      resetFilters === null || resetFilters === void 0 ? void 0 : resetFilters("reset");
    }
  };
  var handleSubmit = function (event) {
    event.preventDefault();
    setSearchInputVal(inputVal);
    resetFilters === null || resetFilters === void 0 ? void 0 : resetFilters("search");
    trackEvent({
      clientPayload: buildClientEvent("reviews_search.submitted" /* SUBMIT */, EVENT_VERSION),
      serverPayload: submittedAnalytics
    });
  };
  var searchBox = /* @__PURE__ */React26.createElement(React26.Fragment, null, /* @__PURE__ */React26.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */React26.createElement(EGDSTextInput, {
    size: 300,
    id: "search-input-box",
    label: label,
    name: name,
    value: inputVal,
    onChange: handleChange,
    hasClearButton: true,
    onClick: function () {
      return trackEvent({
        clientPayload: buildClientEvent("reviews_search.initiated" /* INITIATE */, EVENT_VERSION),
        serverPayload: initiatedAnalytics
      });
    }
  })), /* @__PURE__ */React26.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */React26.createElement(EGDSPrimaryButton2, {
    size: EGDSButtonSize2.LARGE,
    type: "submit",
    name: buttonTitle,
    title: buttonTitle,
    id: "search-btn",
    "aria-label": buttonTitle,
    disabled: (inputVal === null || inputVal === void 0 ? void 0 : inputVal.trim().length) === 0
  }, /* @__PURE__ */React26.createElement(EGDSIcon7, {
    name: iconToken,
    id: iconId
  }))));
  return /* @__PURE__ */React26.createElement(Viewport, null, /* @__PURE__ */React26.createElement(ViewSmall, null, /* @__PURE__ */React26.createElement(EGDSForm, {
    onSubmit: handleSubmit
  }, /* @__PURE__ */React26.createElement(EGDSLayoutFlex8, {
    space: "four"
  }, searchBox))), /* @__PURE__ */React26.createElement(ViewMedium, null, /* @__PURE__ */React26.createElement(EGDSForm, {
    onSubmit: handleSubmit
  }, /* @__PURE__ */React26.createElement(EGDSLayoutFlex8, {
    space: "two"
  }, searchBox))));
};
SearchBox.fragment = fragment14;
SearchBox.displayName = "SearchBox";
var search_box_default = SearchBox;
// src/components/__private/__fragments/sort-type.tsx
import React27, { useMemo as useMemo3 } from "react";
import { gql as gql27 } from "@apollo/client";
import { EGDSSelect } from "@egds/react-core/input";
import { useClickTracker as useClickTracker11 } from "@shared-ui/clickstream-analytics-context";
var fragment15 = gql27(_templateObject29());
var SortType = function (param) {
  var data = param.data,
    setSortType = param.setSortType,
    resetFilters = param.resetFilters;
  var _sortRating_options_;
  var sortRating = data.sortAndFilter.find(function (o) {
    return o.name === "sortBy";
  });
  var _React27_useState = _sliced_to_array(React27.useState((sortRating === null || sortRating === void 0 ? void 0 : (_sortRating_options_ = sortRating.options[0]) === null || _sortRating_options_ === void 0 ? void 0 : _sortRating_options_.optionValue) || ""), 2),
    selectedVal = _React27_useState[0],
    setSelectedVal = _React27_useState[1];
  var tracker = useClickTracker11();
  useMemo3(function () {
    var selectedOption = sortRating === null || sortRating === void 0 ? void 0 : sortRating.options.find(function (o) {
      return o.isSelected === true;
    });
    setSelectedVal((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.optionValue) || "");
  }, [sortRating]);
  if (!sortRating || !sortRating.options || !sortRating.label || sortRating.options.length === 0) {
    return null;
  }
  var name = sortRating.name,
    label = sortRating.label,
    options = sortRating.options;
  var onChangeHandler = function (event) {
    var selectedIndex = event.target.options.selectedIndex;
    var _ref = options[selectedIndex] || {
        clickAnalytics: void 0
      },
      clickAnalytics2 = _ref.clickAnalytics;
    var _ref1 = clickAnalytics2 || {},
      referrerId = _ref1.referrerId,
      linkName = _ref1.linkName;
    if (referrerId && linkName) {
      tracker(referrerId, linkName);
    }
    setSelectedVal(event.currentTarget.value);
    setSortType(event.currentTarget.value);
    resetFilters === null || resetFilters === void 0 ? void 0 : resetFilters("sortBy");
  };
  var clickAnalytics = sortRating.clickAnalytics;
  var onClickHandler = function () {
    var _ref = clickAnalytics || {},
      referrerId = _ref.referrerId,
      linkName = _ref.linkName;
    if (referrerId && linkName) {
      tracker(referrerId, linkName);
    }
  };
  return /* @__PURE__ */React27.createElement(EGDSSelect, {
    id: name,
    value: selectedVal,
    label: label,
    name: name,
    emptyState: false,
    onChange: onChangeHandler,
    onClick: onClickHandler
  }, /* @__PURE__ */React27.createElement(React27.Fragment, null, options.map(function (option, index) {
    if (option.optionValue && option.label) {
      return /* @__PURE__ */React27.createElement("option", {
        key: index,
        value: option.optionValue,
        label: option.label,
        "aria-selected": option.isSelected
      }, option.label);
    }
    return null;
  })));
};
SortType.displayName = "SortType";
SortType.fragment = fragment15;
var sort_type_default = SortType;
// src/components/__private/__fragments/traveler-type.tsx
import React28, { useMemo as useMemo4 } from "react";
import { gql as gql28 } from "@apollo/client";
import { EGDSSelect as EGDSSelect2 } from "@egds/react-core/input";
import { useClickTracker as useClickTracker12 } from "@shared-ui/clickstream-analytics-context";
var fragment16 = gql28(_templateObject30());
var TravelerType = function (param) {
  var data = param.data,
    setTravelerType = param.setTravelerType,
    selectedTravelerTypes = param.selectedTravelerTypes,
    resetFilters = param.resetFilters;
  var _travelerType_options_, _travelerType_options;
  var travelerType = data.sortAndFilter.find(function (travelerOption) {
    return travelerOption.name === "travelerType";
  });
  var _React28_useState = _sliced_to_array(React28.useState((travelerType === null || travelerType === void 0 ? void 0 : (_travelerType_options_ = travelerType.options[0]) === null || _travelerType_options_ === void 0 ? void 0 : _travelerType_options_.optionValue) || ""), 2),
    selectedVal = _React28_useState[0],
    setSelectedVal = _React28_useState[1];
  var tracker = useClickTracker12();
  useMemo4(function () {
    var selectedOption = travelerType === null || travelerType === void 0 ? void 0 : travelerType.options.find(function (travelerOption) {
      return travelerOption.isSelected === true;
    });
    setSelectedVal((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.optionValue) || "");
  }, [travelerType]);
  if (!(travelerType === null || travelerType === void 0 ? void 0 : travelerType.label) || ((_travelerType_options = travelerType.options) === null || _travelerType_options === void 0 ? void 0 : _travelerType_options.length) === 0) {
    return null;
  }
  var name = travelerType.name,
    label = travelerType.label,
    options = travelerType.options;
  var onChangeHandler = function (event) {
    var selectedIndex = event.target.options.selectedIndex;
    var _ref = options[selectedIndex] || {
        clickAnalytics: void 0
      },
      clickAnalytics2 = _ref.clickAnalytics;
    var _ref1 = clickAnalytics2 || {},
      referrerId = _ref1.referrerId,
      linkName = _ref1.linkName;
    if (referrerId && linkName) {
      tracker(referrerId, linkName);
    }
    setSelectedVal(event.currentTarget.value);
    setTravelerType([event.currentTarget.value]);
    resetFilters === null || resetFilters === void 0 ? void 0 : resetFilters("travelerType");
  };
  var clickAnalytics = travelerType.clickAnalytics;
  var onClickHandler = function () {
    var _ref = clickAnalytics || {},
      referrerId = _ref.referrerId,
      linkName = _ref.linkName;
    if (referrerId && linkName) {
      tracker(referrerId, linkName);
    }
  };
  return /* @__PURE__ */React28.createElement(EGDSSelect2, {
    id: name,
    value: selectedVal,
    label: label,
    name: name,
    emptyState: false,
    onChange: onChangeHandler,
    onClick: onClickHandler
  }, /* @__PURE__ */React28.createElement(React28.Fragment, null, options.map(function (option, index) {
    return option.optionValue && option.label ? /* @__PURE__ */React28.createElement("option", {
      key: index,
      value: option.optionValue,
      label: option.label,
      "aria-selected": option.isSelected
    }, option.label) : null;
  })));
};
TravelerType.displayName = "TravelerType";
TravelerType.fragment = fragment16;
var traveler_type_default = TravelerType;
// src/components/property-reviews-highlight-content-wrapper.tsx
import React29 from "react";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { IdentifierType as SummarizedIdentifierType, SummarizedReviews } from "@shared-ui/retail-product-summarized-reviews";
import { IdentifierType, ProductTopRatedAttribute, ProductTopRatedAttributePresent } from "@shared-ui/retail-product-top-rated-attribute";
var AttributePresent = ProductTopRatedAttributePresent;
var PropertyReviewsHighlightContentWrapper = React29.memo(function (param) {
  var propertyId = param.propertyId,
    searchCriteria = param.searchCriteria,
    present = param.present;
  return /* @__PURE__ */React29.createElement(React29.Fragment, null, /* @__PURE__ */React29.createElement(Experiment, {
    name: "PDP_Top_Rated_Properties_Feature_Gate_for_Web"
  }, /* @__PURE__ */React29.createElement(ExperimentControl, null), /* @__PURE__ */React29.createElement(ExperimentVariant, {
    bucket: 1
  }, /* @__PURE__ */React29.createElement(ProductTopRatedAttribute, {
    inputs: {
      productIdentifier: {
        id: propertyId,
        type: IdentifierType.PROPERTY_ID,
        travelSearchCriteria: {
          property: searchCriteria
        }
      }
    },
    skipSsr: true,
    present: present
  }))), ProductTopRatedAttributePresent.REVIEWS_OVERLAY === present && /* @__PURE__ */React29.createElement(SummarizedReviews, {
    inputs: {
      productIdentifier: {
        id: propertyId,
        type: SummarizedIdentifierType.PROPERTY_ID,
        travelSearchCriteria: {
          property: searchCriteria
        }
      }
    }
  }));
});
PropertyReviewsHighlightContentWrapper.displayName = "PropertyReviewsHighlightContentWrapper";
// src/components/property-filtered-reviews.tsx
var __PropertyFilteredReviewsQuery = gql29(_templateObject31(), property_reviews_summary_fragment_default.fragment, PropertyReviewsListFragment, traveler_type_default.fragment, sort_type_default.fragment, search_box_default.fragment, popular_mentions_default.fragment);
var PropertyFilteredReviews = function (param) {
  var _param_inputs = param.inputs,
    propertyId = _param_inputs.propertyId,
    pagination = _param_inputs.pagination,
    includeRecentReviews = _param_inputs.includeRecentReviews,
    searchCriteria = _param_inputs.searchCriteria;
  var context = useBexApi8().context;
  var _useExperiment = useExperiment("Reviews_overlay_migration_no_harm_test_web", true),
    exposureProductReviewDetailsQuery = _useExperiment.exposure;
  var size = (pagination === null || pagination === void 0 ? void 0 : pagination.size) || DEFAULT_PAGINATION_SIZE;
  var startingIndex = (pagination === null || pagination === void 0 ? void 0 : pagination.startingIndex) || DEFAULT_STARTING_INDEX;
  var _React30_useState = _sliced_to_array(React30.useState([]), 2),
    travelerType = _React30_useState[0],
    setTravelerType = _React30_useState[1];
  var _React30_useState1 = _sliced_to_array(React30.useState(DEFAULT_REVIEWS_SORT), 2),
    sortRating = _React30_useState1[0],
    setSortType = _React30_useState1[1];
  var _React30_useState2 = _sliced_to_array(React30.useState(DEFAULT_SEARCH_INPUT), 2),
    searchInputVal = _React30_useState2[0],
    setSearchInputVal = _React30_useState2[1];
  var _React30_useState3 = _sliced_to_array(React30.useState(DEFAULT_POPULAR_MENTION_INPUT), 2),
    popularMentionInput = _React30_useState3[0],
    setPopularMention = _React30_useState3[1];
  var refSearchBoxElement = React30.useRef(null);
  var propertyReviewsHighlightContentElement = useMemo5(function () {
    return /* @__PURE__ */React30.createElement(PropertyReviewsHighlightContentWrapper, {
      propertyId: propertyId,
      searchCriteria: searchCriteria,
      present: AttributePresent.REVIEWS_OVERLAY
    });
  }, [propertyId, searchCriteria]);
  var productReviewDetails = /* @__PURE__ */React30.createElement(ProductReviewDetails, {
    inputs: {
      productIdentifier: {
        id: propertyId,
        type: IdentifierType2.PROPERTY_ID,
        travelSearchCriteria: {
          property: searchCriteria
        }
      }
    },
    skipSsr: true
  });
  var variables = {
    context: context,
    propertyId: propertyId,
    searchCriteria: {
      primary: searchCriteria.primary,
      secondary: {
        booleans: [{
          id: "includeRecentReviews",
          value: includeRecentReviews !== null && includeRecentReviews !== void 0 ? includeRecentReviews : true
        }, {
          id: "includeRatingsOnlyReviews",
          value: true
        }, {
          id: "overrideEmbargoForIndividualReviews",
          value: true
        }, {
          id: "isFilteredSummary",
          value: true
        }],
        counts: [{
          id: "startIndex",
          value: startingIndex
        }, {
          id: "size",
          value: size
        }],
        selections: _to_consumable_array(travelerType.map(function (value) {
          return {
            id: "travelerType",
            value: value
          };
        })).concat([{
          id: "sortBy",
          value: sortRating
        }, {
          id: "searchTerm",
          value: searchInputVal
        }, {
          id: "popularMention",
          value: popularMentionInput
        }])
      }
    }
  };
  var resetFilters = function (type) {
    switch (type) {
      case "search":
        setTravelerType([]);
        setSortType(DEFAULT_REVIEWS_SORT);
        setPopularMention(DEFAULT_POPULAR_MENTION_INPUT);
        break;
      case "popularMention":
        setTravelerType([]);
        setSortType(DEFAULT_REVIEWS_SORT);
        setSearchInputVal(DEFAULT_SEARCH_INPUT);
        break;
      case "travelerType":
      case "sortBy":
        setSearchInputVal(DEFAULT_SEARCH_INPUT);
        setPopularMention(DEFAULT_POPULAR_MENTION_INPUT);
        break;
      case "reset":
      default:
        setTravelerType([]);
        setSortType(DEFAULT_REVIEWS_SORT);
        setSearchInputVal(DEFAULT_SEARCH_INPUT);
        setPopularMention(DEFAULT_POPULAR_MENTION_INPUT);
    }
  };
  var _useQuery6 = useQuery6(__PropertyFilteredReviewsQuery, {
      variables: variables,
      errorPolicy: "all"
    }),
    currentData = _useQuery6.data,
    previousData = _useQuery6.previousData,
    error = _useQuery6.error,
    loading = _useQuery6.loading,
    fetchMore = _useQuery6.fetchMore;
  var paginationFetch = buildFetchMoreReviews(fetchMore, variables);
  var data = currentData !== null && currentData !== void 0 ? currentData : previousData;
  React30.useEffect(function () {
    if (searchInputVal.length > 0) {
      var _refSearchBoxElement_current;
      (_refSearchBoxElement_current = refSearchBoxElement.current) === null || _refSearchBoxElement_current === void 0 ? void 0 : _refSearchBoxElement_current.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  }, [searchInputVal]);
  if (loading && sortRating === DEFAULT_REVIEWS_SORT && !searchInputVal && travelerType.length === 0 && !popularMentionInput) {
    return /* @__PURE__ */React30.createElement(EGDSLayoutFlex9, null, /* @__PURE__ */React30.createElement(EGDSLayoutPosition, {
      type: "absolute",
      position: {
        top: "center",
        left: "center"
      }
    }, /* @__PURE__ */React30.createElement(EGDSLoader, null), exposureProductReviewDetailsQuery.bucket === 1 && /* @__PURE__ */React30.createElement("span", {
      className: "is-visually-hidden"
    }, productReviewDetails)));
  }
  if (error || !data) {
    return null;
  }
  var reviewInfo = data.propertyInfo.reviewInfo;
  var reviewsContent = null;
  if (loading) {
    reviewsContent = /* @__PURE__ */React30.createElement("div", {
      "data-stid": "property-reviews-list-loading"
    }, /* @__PURE__ */React30.createElement(EGDSCard3, {
      padded: true
    }, Array.from(Array(3)).map(function (_, index) {
      return /* @__PURE__ */React30.createElement(EGDSCardContentSection2, {
        border: "bottom",
        key: index
      }, /* @__PURE__ */React30.createElement(EGDSLayoutFlex9, {
        direction: "column",
        space: "three"
      }, /* @__PURE__ */React30.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */React30.createElement(EGDSLineSkeleton, {
        animation: true
      })), /* @__PURE__ */React30.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */React30.createElement(EGDSLineSkeleton, {
        animation: true,
        type: "secondary"
      })), /* @__PURE__ */React30.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */React30.createElement(EGDSFigure2, {
        ratio: EGDSFigureAspectRatioType2.R4_1
      }, /* @__PURE__ */React30.createElement(EGDSBlockSkeleton, null)))));
    })));
  } else {
    reviewsContent = /* @__PURE__ */React30.createElement("div", {
      "data-stid": "property-reviews-list"
    }, /* @__PURE__ */React30.createElement(property_reviews_list_default, {
      propertyId: propertyId,
      size: size,
      data: reviewInfo,
      fetchMore: paginationFetch,
      reviewsPage: "ReviewsOverlay" /* REVIEWS_OVERLAY */
    }));
  }
  var sortComponent = /* @__PURE__ */React30.createElement("div", {
    "data-stid": "property-reviews-sort"
  }, /* @__PURE__ */React30.createElement(sort_type_default, {
    selectedSortTypes: sortRating,
    setSortType: setSortType,
    data: reviewInfo.sortAndFilter,
    resetFilters: resetFilters
  }));
  var searchComponent = /* @__PURE__ */React30.createElement("div", {
    "data-stid": "property-reviews-search",
    ref: refSearchBoxElement
  }, /* @__PURE__ */React30.createElement(search_box_default, {
    data: reviewInfo.sortAndFilter,
    setSearchInputVal: setSearchInputVal,
    searchInputVal: searchInputVal,
    resetFilters: resetFilters
  }));
  var popularMentionsComponent = /* @__PURE__ */React30.createElement("div", {
    "data-stid": "property-reviews-popular-mentions"
  }, /* @__PURE__ */React30.createElement(popular_mentions_default, {
    data: reviewInfo.sortAndFilter,
    popularMentionInput: popularMentionInput,
    resetFilters: resetFilters,
    setPopularMention: setPopularMention,
    otherFiltersApplied: searchInputVal !== DEFAULT_SEARCH_INPUT || travelerType.length > 0 && travelerType[0] !== DEFAULT_TRAVELER_TYPE
  }));
  return /* @__PURE__ */React30.createElement(EGDSLayoutGrid2, {
    columns: {
      small: 1,
      medium: 1,
      large: 1
    },
    space: "six"
  }, exposureProductReviewDetailsQuery.bucket === 0 ? /* @__PURE__ */React30.createElement("div", null, !!data.propertyReviewSummaries.length && data.propertyReviewSummaries[0] && /* @__PURE__ */React30.createElement(property_reviews_summary_fragment_default, {
    data: data.propertyReviewSummaries[0],
    reviewPage: "ReviewsOverlay" /* REVIEWS_OVERLAY */.valueOf()
  }, propertyReviewsHighlightContentElement)) : productReviewDetails, /* @__PURE__ */React30.createElement(EGDSLayoutGrid2, {
    columns: {
      small: 1,
      medium: 1,
      large: 1
    }
  }, /* @__PURE__ */React30.createElement(EGDSLayoutGrid2, {
    columns: 1
  }, /* @__PURE__ */React30.createElement(EGDSSpacing17, {
    margin: {
      blockend: "six"
    }
  }, /* @__PURE__ */React30.createElement(EGDSLayoutGridItem2, null, searchComponent))), /* @__PURE__ */React30.createElement(EGDSLayoutGrid2, {
    columns: 1
  }, /* @__PURE__ */React30.createElement(EGDSLayoutGridItem2, null, popularMentionsComponent)), /* @__PURE__ */React30.createElement(EGDSLayoutGrid2, {
    columns: 2,
    space: "six"
  }, /* @__PURE__ */React30.createElement(EGDSLayoutGridItem2, null, /* @__PURE__ */React30.createElement(EGDSLayoutFlexItem7, {
    minWidth: 205
  }, sortComponent)), /* @__PURE__ */React30.createElement(EGDSLayoutGridItem2, null, /* @__PURE__ */React30.createElement(traveler_type_default, {
    selectedTravelerTypes: travelerType,
    setTravelerType: setTravelerType,
    data: reviewInfo.sortAndFilter,
    resetFilters: resetFilters
  }))), /* @__PURE__ */React30.createElement(EGDSSpacing17, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React30.createElement(EGDSLayoutGridItem2, null, reviewsContent))));
};
PropertyFilteredReviews.displayName = "sharedui-PropertyFilteredReviews";
var property_filtered_reviews_default = PropertyFilteredReviews;
// src/components/property-reviews-breakdown.tsx
var __PropertyReviewBreakdownQuery = gql30(_templateObject32(), PropertyReviewsBreakdownFragment.fragment);
var PropertyReviewsBreakdown = function (param) {
  var _param_withAggregateRating = param.withAggregateRating,
    withAggregateRating = _param_withAggregateRating === void 0 ? false : _param_withAggregateRating,
    onClickLink = param.onClickLink,
    _param_inputs = param.inputs,
    propertyId = _param_inputs.propertyId,
    searchCriteria = _param_inputs.searchCriteria;
  var context = useBexApi9().context;
  var variables = {
    context: context,
    propertyIds: [propertyId]
  };
  var _useQuery7 = useQuery7(__PropertyReviewBreakdownQuery, {
      variables: variables,
      errorPolicy: "all",
      fetchPolicy: "cache-first"
    }),
    data = _useQuery7.data,
    error = _useQuery7.error,
    loading = _useQuery7.loading;
  if (loading || error || !(data === null || data === void 0 ? void 0 : data.propertyReviewSummaries) || !data.propertyReviewSummaries.length || !data.propertyReviewSummaries[0]) {
    return null;
  }
  var PropertyFilteredReviewsDialogContent = React31.memo(function () {
    return /* @__PURE__ */React31.createElement(property_filtered_reviews_default, {
      inputs: {
        propertyId: propertyId,
        searchCriteria: searchCriteria,
        includeRecentReviews: true
      }
    });
  });
  PropertyFilteredReviewsDialogContent.displayName = "PropertyFilteredReviewsDialogContent";
  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    /* @__PURE__ */
    React31.createElement(PropertyFilteredReviewsDialogContext.Provider, {
      value: {
        PropertyFilteredReviewsDialogContent: PropertyFilteredReviewsDialogContent
      }
    }, /* @__PURE__ */React31.createElement(EGDSSpacing18, {
      padding: {
        blockstart: "three",
        inline: "three",
        large: {
          blockend: "three"
        }
      }
    }, /* @__PURE__ */React31.createElement("div", null, /* @__PURE__ */React31.createElement(PropertyReviewsBreakdownFragment, {
      withAggregateRating: withAggregateRating,
      data: data.propertyReviewSummaries[0],
      onClickLink: onClickLink
    }))))
  );
};
PropertyReviewsBreakdown.displayName = "sharedui-PropertyReviewsBreakdown";
// src/components/property-reviews.tsx
import React32, { useMemo as useMemo6 } from "react";
import { gql as gql31, useQuery as useQuery8 } from "@apollo/client";
import { EGDSSecondaryButton as EGDSSecondaryButton2 } from "@egds/react-core/button";
import { EGDSCard as EGDSCard4, EGDSCardContentSection as EGDSCardContentSection3 } from "@egds/react-core/cards";
import { EGDSLayoutGrid as EGDSLayoutGrid3, EGDSLayoutGridItem as EGDSLayoutGridItem3 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing19 } from "@egds/react-core/spacing";
import { useBexApi as useBexApi10 } from "@shared-ui/bex-api-context";
import { EgClickstreamImpressionTracker as EgClickstreamImpressionTracker3, useClickTracker as useClickTracker13 } from "@shared-ui/clickstream-analytics-context";
import { Experiment as Experiment2, ExperimentControl as ExperimentControl2, ExperimentVariant as ExperimentVariant2, useExperiment as useExperiment2 } from "@shared-ui/experiment-context";
import { PropertyFilteredReviewsDialogContext as PropertyFilteredReviewsDialogContext2, PropertyReviewsBreakdown as PropertyReviewsBreakdownFragment2 } from "@shared-ui/lodging-fragments";
var __PropertyReviewsQuery = gql31(_templateObject33(), PropertyReviewsBreakdownFragment2.fragment, PropertyReviewsListFragment);
var PropertyReviews = function (param) {
  var onClickLink = param.onClickLink,
    hideManagementResponse = param.hideManagementResponse,
    _param_inputs = param.inputs,
    propertyId = _param_inputs.propertyId,
    pagination = _param_inputs.pagination,
    includeRecentReviews = _param_inputs.includeRecentReviews,
    searchCriteria = _param_inputs.searchCriteria;
  var _useBexApi10_context_device, _useBexApi10_context;
  var context = useBexApi10().context;
  var exposure = useExperiment2("Progressive_Disclosure_Web").exposure;
  var startingIndex = (pagination === null || pagination === void 0 ? void 0 : pagination.startingIndex) || DEFAULT_STARTING_INDEX;
  var isMobile = ((_useBexApi10_context = useBexApi10().context) === null || _useBexApi10_context === void 0 ? void 0 : (_useBexApi10_context_device = _useBexApi10_context.device) === null || _useBexApi10_context_device === void 0 ? void 0 : _useBexApi10_context_device.type) === "MOBILE_PHONE" /* MOBILE_PHONE */;
  var size = (pagination === null || pagination === void 0 ? void 0 : pagination.size) || DEFAULT_PAGINATION_SIZE;
  if (exposure.bucket === 1 && isMobile && startingIndex === 0) {
    size = DEFAULT_PAGINATION_SIZE_PROGRESSIVE_DISCLOSURE;
  }
  var variables = {
    context: context,
    propertyId: propertyId,
    searchCriteria: {
      primary: searchCriteria.primary,
      secondary: {
        booleans: [{
          id: "includeRecentReviews",
          value: includeRecentReviews !== null && includeRecentReviews !== void 0 ? includeRecentReviews : true
        }, {
          id: "includeRatingsOnlyReviews",
          value: true
        }, {
          id: "overrideEmbargoForIndividualReviews",
          value: false
        }, {
          id: "isReviewsSummary",
          value: true
        }, {
          id: "isFilteredSummary",
          value: false
        }],
        counts: [{
          id: "startIndex",
          value: startingIndex
        }, {
          id: "size",
          value: size
        }],
        selections: [{
          id: "sortBy",
          value: DEFAULT_REVIEWS_SORT
        }]
      }
    }
  };
  var tracker = useClickTracker13();
  var trackedOnClickSeeAll = React32.useCallback(function () {
    if (onClickLink) {
      tracker(SEE_ALL_REVIEWS_TRACKER.rfrr, SEE_ALL_REVIEWS_TRACKER.link);
      onClickLink();
    }
  }, [onClickLink, tracker]);
  var propertyReviewsHighlightContentElement = useMemo6(function () {
    return /* @__PURE__ */React32.createElement(PropertyReviewsHighlightContentWrapper, {
      propertyId: propertyId,
      searchCriteria: searchCriteria,
      present: AttributePresent.REVIEWS_BOTTOM
    });
  }, [propertyId, searchCriteria]);
  var PropertyFilteredReviewsDialogContent = React32.memo(function () {
    return /* @__PURE__ */React32.createElement(property_filtered_reviews_default, {
      inputs: {
        propertyId: propertyId,
        searchCriteria: searchCriteria,
        includeRecentReviews: includeRecentReviews
      }
    });
  });
  PropertyFilteredReviewsDialogContent.displayName = "PropertyFilteredReviewsDialogContent";
  var propertyFilteredReviewsDialogContext = useMemo6(function () {
    return {
      PropertyFilteredReviewsDialogContent: PropertyFilteredReviewsDialogContent
    };
  }, [PropertyFilteredReviewsDialogContent]);
  var _useQuery8 = useQuery8(__PropertyReviewsQuery, {
      variables: variables,
      errorPolicy: "all",
      fetchPolicy: "cache-first"
    }),
    data = _useQuery8.data,
    error = _useQuery8.error,
    loading = _useQuery8.loading,
    fetchMore = _useQuery8.fetchMore;
  if (error || loading || !data) {
    return null;
  }
  var _data_propertyInfo_reviewInfo = data.propertyInfo.reviewInfo,
    summary = _data_propertyInfo_reviewInfo.summary,
    reviews = _data_propertyInfo_reviewInfo.reviews,
    noResultsMessage = _data_propertyInfo_reviewInfo.noResultsMessage;
  var impressionAnalytics = {
    clientPayload: buildReviewsEvent("reviews.presented" /* REVIEWS_PRESENTED */, EVENT_VERSION, EVENT_TYPE, "pdp" /* REVIEWS */)
  };
  if (!summary) {
    return null;
  }
  var paginationFetch = buildFetchMoreReviews(fetchMore, variables);
  var seeAllReviewsCallToActionLabel = summary.seeAllReviewsCallToActionLabel,
    accessibilityLabel = summary.accessibilityLabel,
    strategy = summary.strategy,
    raw = summary.totalCount.raw;
  if (!noResultsMessage && raw === 0) {
    return null;
  }
  var RenderPropertyReviews = /* @__PURE__ */React32.createElement(React32.Fragment, null, /* @__PURE__ */React32.createElement(EGDSLayoutGridItem3, {
    colSpan: {
      small: 1,
      medium: 1,
      large: 1
    }
  }, /* @__PURE__ */React32.createElement("div", null, /* @__PURE__ */React32.createElement(EGDSSpacing19, {
    padding: {
      blockstart: "three",
      inline: "three",
      large: {
        blockend: "three"
      }
    }
  }, /* @__PURE__ */React32.createElement("div", null, /* @__PURE__ */React32.createElement(PropertyReviewsBreakdownFragment2, {
    data: summary,
    onClickLink: trackedOnClickSeeAll,
    reviewPage: "Reviews" /* BOTTOM_PDP */.valueOf()
  }, propertyReviewsHighlightContentElement))))), /* @__PURE__ */React32.createElement(EGDSLayoutGridItem3, {
    colSpan: {
      small: 1,
      medium: 1,
      large: 2
    }
  }, /* @__PURE__ */React32.createElement("div", null, /* @__PURE__ */React32.createElement("h2", {
    className: "is-visually-hidden"
  }, accessibilityLabel), /* @__PURE__ */React32.createElement(property_reviews_list_default, {
    size: size,
    data: data.propertyInfo.reviewInfo,
    fetchMore: paginationFetch,
    hideManagementResponse: hideManagementResponse,
    showLoadMoreCTA: false,
    propertyId: propertyId,
    reviewsPage: "Reviews" /* BOTTOM_PDP */
  }), seeAllReviewsCallToActionLabel && onClickLink && reviews.length > 0 && /* @__PURE__ */React32.createElement(EGDSSpacing19, {
    margin: {
      block: "three"
    }
  }, /* @__PURE__ */React32.createElement("div", null, /* @__PURE__ */React32.createElement(EGDSSecondaryButton2, {
    onClick: trackedOnClickSeeAll
  }, seeAllReviewsCallToActionLabel))))));
  var ThirdPartyPropertyReviews = /* @__PURE__ */React32.createElement(EGDSLayoutGridItem3, {
    colSpan: {
      small: 1,
      medium: 1,
      large: 1
    }
  }, /* @__PURE__ */React32.createElement("div", null, /* @__PURE__ */React32.createElement(EGDSSpacing19, {
    padding: {
      blockstart: "three",
      inline: "three",
      large: {
        blockend: "three"
      }
    }
  }, /* @__PURE__ */React32.createElement("div", null, /* @__PURE__ */React32.createElement(PropertyReviewsBreakdownFragment2, {
    data: summary,
    onClickLink: trackedOnClickSeeAll,
    reviewPage: "Reviews" /* BOTTOM_PDP */.valueOf()
  }, propertyReviewsHighlightContentElement)))));
  var RenderReviewsWithImpression = /* @__PURE__ */React32.createElement(EgClickstreamImpressionTracker3, {
    eventData: impressionAnalytics
  }, RenderPropertyReviews);
  var ThirdPartyReviewsWithImpression = /* @__PURE__ */React32.createElement(EgClickstreamImpressionTracker3, {
    eventData: impressionAnalytics
  }, ThirdPartyPropertyReviews);
  return /* @__PURE__ */React32.createElement(PropertyFilteredReviewsDialogContext2.Provider, {
    value: propertyFilteredReviewsDialogContext
  }, /* @__PURE__ */React32.createElement(EGDSCard4, null, /* @__PURE__ */React32.createElement(EGDSCardContentSection3, null, /* @__PURE__ */React32.createElement("h2", {
    className: "is-visually-hidden"
  }, accessibilityLabel), /* @__PURE__ */React32.createElement(EGDSLayoutGrid3, {
    columns: {
      small: 1,
      medium: 1,
      large: 3
    }
  }, /* @__PURE__ */React32.createElement(Experiment2, {
    name: "External_reviews_display_SRP_and_PDP"
  }, /* @__PURE__ */React32.createElement(ExperimentControl2, null, RenderReviewsWithImpression), /* @__PURE__ */React32.createElement(ExperimentVariant2, {
    bucket: 1
  }, strategy === "EXTERNAL_REVIEWS" /* EXTERNAL_REVIEWS */ ? ThirdPartyReviewsWithImpression : RenderReviewsWithImpression))))));
};
PropertyReviews.displayName = "sharedui-PropertyReviews";
// src/components/property-room-scores.tsx
import React33 from "react";
import { gql as gql32, useQuery as useQuery9 } from "@apollo/client";
import { EGDSList, EGDSListItem } from "@egds/react-core/list";
import { EGDSLineSkeleton as EGDSLineSkeleton2 } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing20 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading8, EGDSText as EGDSText16 } from "@egds/react-core/text";
import { useBexApi as useBexApi11 } from "@shared-ui/bex-api-context";
var __PropertyRoomScoresQuery = gql32(_templateObject34());
var getRoomScoreFromData = function (roomId, data) {
  var propertySummaries = data.propertySummaries;
  var propertySummary = propertySummaries === null || propertySummaries === void 0 ? void 0 : propertySummaries.find(function (element) {
    return element;
  });
  var roomsScore = propertySummary === null || propertySummary === void 0 ? void 0 : propertySummary.roomsScore;
  return roomsScore === null || roomsScore === void 0 ? void 0 : roomsScore.find(function (element) {
    return element.id === roomId;
  });
};
var PropertyRoomScore = function (param) {
  var _param_inputs = param.inputs,
    propertyId = _param_inputs.propertyId,
    withTags = _param_inputs.withTags,
    roomId = param.roomId,
    skipSsr = param.skipSsr,
    _param_withinDialog = param.withinDialog,
    withinDialog = _param_withinDialog === void 0 ? false : _param_withinDialog;
  var context = useBexApi11().context;
  var variables = {
    context: context,
    propertyIds: [propertyId],
    withTags: withTags
  };
  var _useQuery9 = useQuery9(__PropertyRoomScoresQuery, {
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery9.data,
    error = _useQuery9.error,
    loading = _useQuery9.loading;
  if (loading) {
    return /* @__PURE__ */React33.createElement(EGDSLineSkeleton2, {
      animation: false
    });
  }
  if (error || !data) {
    return null;
  }
  var roomScore = getRoomScoreFromData(roomId, data.propertyReviewAggregates);
  if (!roomScore) {
    return null;
  }
  var scoreLabel = roomScore.scoreLabel,
    roomRatingListTitle = roomScore.roomRatingListTitle,
    tags = roomScore.tags;
  if (withinDialog) {
    return /* @__PURE__ */React33.createElement(EGDSSpacing20, {
      margin: {
        blockend: "six"
      }
    }, /* @__PURE__ */React33.createElement("div", null, /* @__PURE__ */React33.createElement(EGDSSpacing20, {
      margin: {
        blockend: "three"
      }
    }, /* @__PURE__ */React33.createElement(EGDSHeading8, {
      size: 5,
      tag: "h3"
    }, scoreLabel)), tags && tags.length > 0 && /* @__PURE__ */React33.createElement("div", null, /* @__PURE__ */React33.createElement(EGDSHeading8, {
      size: 7,
      tag: "h4"
    }, roomRatingListTitle), /* @__PURE__ */React33.createElement(EGDSList, {
      bullet: "no-bullet"
    }, tags.map(function (tag, index) {
      return /* @__PURE__ */React33.createElement(EGDSListItem, {
        key: "tag-".concat(index)
      }, tag.label);
    })))));
  }
  return /* @__PURE__ */React33.createElement(EGDSText16, null, scoreLabel);
};
export { PropertyFilteredReviews, PropertyReviews, PropertyReviewsBreakdown, PropertyReviewsList2 as PropertyReviewsList, PropertyReviewsSnippets, PropertyReviewsSummary, PropertyReviewsSummaryLine, PropertyRoomScore }; /* istanbul ignore next -- @preserve */